(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64467);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83915:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/fire-own.efe23846.svg","height":100,"width":100});

/***/ }),

/***/ 92537:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/round-nerd-large.ee7c7109.svg","height":80,"width":80});

/***/ }),

/***/ 33040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24975);
/* harmony import */ var _Emoji__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62290);



const ConditionalLink = (param)=>{
    let { className ="" , link , children  } = param;
    return link === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "\n        hover:brightness-90 active:brightness-75\n        ".concat(className, "\n      "),
        href: link,
        rel: "noreferrer",
        children: children
    });
};
const Title = (param)=>/*#__PURE__*/ {
    let { highlightGradient ="bg-gradient-to-tr from-gray-800 to-pink-400" , highlightPhrase , link , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ConditionalLink, {
        className: "flex items-center gap-x-4 text-white",
        link: link === undefined ? undefined : "#".concat(link),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: "\n        flex\n        text-center font-inter\n        text-2xl font-extralight text-white md:text-3xl xl:text-4xl\n      ",
                children: [
                    title,
                    highlightPhrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "bg-clip-text text-transparent ".concat(highlightGradient),
                                children: highlightPhrase
                            })
                        ]
                    })
                ]
            }),
            link !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-4 pt-3 md:w-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                        className: "hidden md:block",
                        alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                        name: "link",
                        width: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                        className: "block md:hidden",
                        alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                        name: "link",
                        width: 16
                    })
                ]
            })
        ]
    });
};
const ErrorFallback = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-32 mb-32 pt-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-center font-inter text-2xl font-extralight text-white md:text-3xl xl:text-4xl",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col justify-center text-slateus-400",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "\n          m-16 mx-auto w-5/6 rounded-lg border border-red-400 bg-slateus-700\n          p-8 text-center font-roboto text-base font-light text-white\n        ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-4",
                            children: "This section hit an exception \uD83D\uDE31"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mb-2",
                            children: [
                                "We're sorry, this should never happen! If you've seen this before, or reloading doesn't fix it, you can help debug it by sending a screenshot to",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "ml-2 cursor-pointer text-slateus-200 underline active:brightness-90",
                                    href: "https://twitter.com/ultrasoundmoney/",
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: "@ultrasoundmoney"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const Section = (param)=>/*#__PURE__*/ {
    let { children , highlightGradient ="bg-gradient-to-tr from-gray-800 to-pink-400" , highlightPhrase , link , subtitle , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .ErrorBoundary */ .SV, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ErrorFallback, {
            title: title
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "mt-32 flex flex-col items-center gap-4 gap-x-4 pt-32 xs:px-4 md:px-16",
            id: link,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    title: title,
                    link: link,
                    highlightGradient: highlightGradient,
                    highlightPhrase: highlightPhrase
                }),
                subtitle !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-6 text-center font-inter text-base font-light text-slateus-400 lg:text-lg",
                    children: subtitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-32"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 76688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LabelUnitText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90917);


const LabelUnitText = (param)=>/*#__PURE__*/ {
    let { children , className =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
        className: "tracking-widest ".concat(className),
        color: "text-slateus-200",
        font: "font-roboto",
        size: "text-xs",
        weight: "font-light",
        lineHeight: "leading-[14px]",
        children: children
    });
};


/***/ }),

/***/ 5429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ LondonHardForkTooltip; },
  "Z": function() { return /* binding */ components_TimeFrameControl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/assets/fire-own.svg
var fire_own = __webpack_require__(83915);
;// CONCATENATED MODULE: ./src/assets/fire-slateus.svg
/* harmony default export */ var fire_slateus = ({"src":"/_next/static/media/fire-slateus.aefa304c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/panda-own.svg
/* harmony default export */ var panda_own = ({"src":"/_next/static/media/panda-own.8181cb98.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/panda-slateus.svg
/* harmony default export */ var panda_slateus = ({"src":"/_next/static/media/panda-slateus.657029a6.svg","height":100,"width":100});
// EXTERNAL MODULE: ./src/mainsite/time-frames.ts
var time_frames = __webpack_require__(78868);
// EXTERNAL MODULE: ./src/mainsite/components/HoverTooltip.tsx
var HoverTooltip = __webpack_require__(56862);
;// CONCATENATED MODULE: ./src/components/TimeFrameControl.tsx








const Button = (param)=>/*#__PURE__*/ {
    let { children , isActive , onClick , disabled , title  } = param;
    return (0,jsx_runtime.jsx)("button", {
        className: "\n      select-none rounded-sm\n      border px-[10px] py-2\n      font-roboto \n      text-xs\n      font-normal\n      tracking-widest\n      ".concat(disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer", "\n      ").concat(isActive && !disabled ? "border-slateus-400 bg-slateus-600 text-white" : "border-transparent text-slateus-200", "\n    "),
        onClick: disabled ? undefined : onClick,
        title: title ? title : undefined,
        children: children
    });
};
const LondonHardForkTooltip = (param)=>/*#__PURE__*/ {
    let { children , timeFrame , zLevel  } = param;
    return (0,jsx_runtime.jsx)(HoverTooltip/* default */.Z, {
        customAlign: "-left-32",
        text: timeFrame === "since_burn" ? "Since-burn time frame. Starting from the london hard fork where EIP-1559 was activated." : undefined,
        zLevel: zLevel,
        children: children
    });
};
const FireImage = (param)=>/*#__PURE__*/ {
    let { selectedTimeframe  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_burn" ? "hidden" : "block", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: selectedTimeframe === "since_burn" ? "hidden" : "block",
                    alt: "flame emoji symbolizing time span since london hard fork when EIP-1559 was activated",
                    src: fire_slateus,
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_burn" ? "block" : "hidden", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "flame emoji symbolizing time span since london hard fork when EIP-1559 was activated",
                    src: fire_own/* default */.Z,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
};
const PandaImage = (param)=>/*#__PURE__*/ {
    let { selectedTimeframe  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_merge" ? "hidden" : "block", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: selectedTimeframe === "since_merge" ? "hidden" : "block",
                    alt: "panda emoji symbolizing the time span since the merge happened",
                    src: panda_slateus,
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_merge" ? "block" : "hidden", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "panda emoji symbolizing the time span since the merge happened",
                    src: panda_own,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
};
const TimeFrameControlCensorship = (param)=>/*#__PURE__*/ {
    let { selectedTimeFrame , onSetTimeFrame  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row items-center lg:gap-x-1",
        children: [
            "d1",
            "d7",
            "d30",
            "since_merge"
        ].map((timeFrame)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LondonHardForkTooltip, {
                timeFrame: timeFrame,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    isActive: selectedTimeFrame === timeFrame,
                    onClick: (_e)=>onSetTimeFrame(timeFrame),
                    disabled: timeFrame === "since_merge" || timeFrame === "d1",
                    title: "coming soon",
                    children: timeFrame === "since_merge" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PandaImage, {
                        selectedTimeframe: selectedTimeFrame
                    }) : time_frames/* displayLimitedTimeFrameMap */.I1[timeFrame]
                })
            }, timeFrame))
    });
};
const TimeFrameControl = (param)=>{
    let { selectedTimeFrame: selectedTimeframe , onSetTimeFrame , version ="all"  } = param;
    return version === "censorship" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameControlCensorship, {
        selectedTimeFrame: selectedTimeframe,
        onSetTimeFrame: onSetTimeFrame
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row flex-wrap items-center lg:gap-x-1",
        children: time_frames/* timeFrames.map */.hN.map((timeFrame)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LondonHardForkTooltip, {
                timeFrame: timeFrame,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    isActive: selectedTimeframe === timeFrame,
                    onClick: (_e)=>onSetTimeFrame(timeFrame),
                    children: timeFrame === "since_merge" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PandaImage, {
                        selectedTimeframe: selectedTimeframe
                    }) : timeFrame === "since_burn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FireImage, {
                        selectedTimeframe: selectedTimeframe
                    }) : time_frames/* displayLimitedTimeFrameMap */.I1[timeFrame]
                })
            }, timeFrame))
    });
};
/* harmony default export */ var components_TimeFrameControl = (TimeFrameControl);


/***/ }),

/***/ 46400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_WidgetErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
;// CONCATENATED MODULE: ./src/components/ErrorWidget.tsx

const ErrorWidget = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "w-full rounded-lg border border-red-400 bg-slateus-700 p-8 font-roboto text-base font-light text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-8 font-inter text-xs font-light uppercase tracking-widest text-slateus-200",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-4",
                children: "An exception has occurred \uD83D\uDE31"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-2",
                children: [
                    "We're sorry, this should never happen! If you've seen this before, or reloading doesn't fix it, you can help debug it by sending a screenshot to",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "ml-2 cursor-pointer text-slateus-200 underline active:brightness-90",
                        href: "https://twitter.com/ultrasoundmoney/",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "@ultrasoundmoney"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ErrorWidget = (ErrorWidget);

;// CONCATENATED MODULE: ./src/components/WidgetErrorBoundary.tsx



const WidgetErrorBoundary = (param)=>/*#__PURE__*/ {
    let { children , title  } = param;
    return (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ErrorWidget, {
            title: title
        }),
        children: children
    });
};
/* harmony default export */ var components_WidgetErrorBoundary = (WidgetErrorBoundary);


/***/ }),

/***/ 20929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getApiDomain; },
/* harmony export */   "g": function() { return /* binding */ versionFromEnv; }
/* harmony export */ });
const getApiDomain = ()=>{
    var _NEXT_PUBLIC_ENV;
    const apiEnv = (_NEXT_PUBLIC_ENV = "prod") !== null && _NEXT_PUBLIC_ENV !== void 0 ? _NEXT_PUBLIC_ENV : "prod";
    switch(apiEnv){
        case "dev":
            return "https://ultrasound.money";
        case "stag":
            return "https://usm-i7x0.ultrasound.money";
        case "prod":
            return "https://ultrasound.money";
    }
};
// We expect these to be set by the build process.
const versionFromEnv = ()=>{
    const tags = "main";
    const commit = "db520db01889fac1ecac81ff07c2b46df41fb7aa";
    const shortTagVersion = typeof tags !== "string" ? undefined : tags.split("-")[1];
    const shortCommitVersion = typeof commit !== "string" ? undefined : commit.slice(0, 7);
    if (shortTagVersion && shortCommitVersion) {
        return "".concat(shortTagVersion, "-").concat(shortCommitVersion);
    }
    if (shortTagVersion) {
        return shortTagVersion;
    }
    if (shortCommitVersion) {
        return shortCommitVersion;
    }
    return "unknown";
};


/***/ }),

/***/ 71119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ ico; },
/* harmony export */   "Lk": function() { return /* binding */ parisHardFork; },
/* harmony export */   "b9": function() { return /* binding */ londonHardFork; },
/* harmony export */   "s_": function() { return /* binding */ mergeDateTime; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23855);

const ico = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("2014-09-02T00:00:00.000Z");
const londonHardFork = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("2021-08-05T12:33:42.000Z");
const parisHardFork = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("2022-09-15T06:42:42Z");
const mergeDateTime = parisHardFork;


/***/ }),

/***/ 5964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Io": function() { return /* binding */ millisFromSeconds; },
/* harmony export */   "QN": function() { return /* binding */ millisFromHours; },
/* harmony export */   "kY": function() { return /* binding */ millisFromDays; },
/* harmony export */   "wb": function() { return /* binding */ millisFromMinutes; }
/* harmony export */ });
/* unused harmony exports secsFromDays, secsFromMinutes */
const millisFromSeconds = (seconds)=>seconds * 1000;
const millisFromMinutes = (minutes)=>minutes * 60 * 1000;
const millisFromHours = (hours)=>hours * 60 * 60 * 1000;
const millisFromDays = (days)=>days * 24 * 60 * 60 * 1000;
const secsFromDays = (days)=>days * 24 * 60 * 60;
const secsFromMinutes = (minutes)=>minutes * 60;


/***/ }),

/***/ 84450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useBaseFeePerGasBarrier; }
/* harmony export */ });
/* unused harmony export fetchBaseFeePerGasBarrier */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62523);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);




const url = "/api/v2/fees/base-fee-per-gas-barrier";
const fetchBaseFeePerGasBarrier = ()=>fetchApiJson(url);
const useBaseFeePerGasBarrier = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(60)
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 40662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useBaseFeeOverTime; }
/* harmony export */ });
/* unused harmony export fetchBaseFeeOverTime */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62523);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);




const url = "/api/v2/fees/base-fee-over-time";
const fetchBaseFeeOverTime = ()=>fetchApiJson(url);
const useBaseFeeOverTime = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(4)
    });
    return data;
};


/***/ }),

/***/ 46983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useBurnSums; }
/* harmony export */ });
/* unused harmony export fetchBurnSums */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62523);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);




const url = "/api/v2/fees/burn-sums";
const fetchBurnSums = ()=>fetchApiJson(url);
const useBurnSums = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(4)
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 92679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useEthPriceStats; }
/* harmony export */ });
/* unused harmony export fetchEthPriceStats */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62523);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);



const url = "/api/v2/fees/eth-price-stats";
const fetchEthPriceStats = ()=>fetchApiJson(url);
const useEthPriceStats = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(10),
        refreshWhenHidden: true
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 78051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ar": function() { return /* binding */ fetchJsonSwr; }
});

// UNUSED EXPORTS: fetchApiJson, fetchApiJsonTE

// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(20929);
// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
;// CONCATENATED MODULE: ./src/fetchers.ts

const fetchSafe = async (url)=>{
    // Make a request, catch Fetch errors.
    try {
        const res = await fetch(url);
        return {
            res,
            type: "Response"
        };
    } catch (error) {
        if (error instanceof Error) {
            return {
                error,
                type: "FetchError"
            };
        }
        return {
            error: new Error(String(error)),
            type: "FetchError"
        };
    }
};
// Convert relative URLs to absolute, the server wouldn't know where to go
// otherwise.
const absoluteUrlFromUrl = (domain, url)=>typeof url === "string" && url.startsWith("https://") ? url : "".concat(domain).concat(url);
/** Fetch a JSON API response, and return the data, or an error. */ const fetchApiJson = async (apiDomain, url)=>{
    const absoluteUrl = absoluteUrlFromUrl(apiDomain, url);
    const safeRes = await fetchSafe(absoluteUrl);
    if (safeRes.type === "FetchError") {
        return safeRes;
    }
    const res = safeRes.res;
    if (res.status === 200) {
        // This function is meant to only fetch JSON API responses. If we can't
        // decode a json body, we let the error bubble.
        const body = await res.json();
        return {
            data: body
        };
    }
    // Something went wrong, there may be a json body with a hint, there may not.
    try {
        const body1 = await res.json();
        const message = (body1 === null || body1 === void 0 ? void 0 : body1.message) || (body1 === null || body1 === void 0 ? void 0 : body1.msg);
        if (typeof message === "string") {
            const error = new Error("failed to fetch ".concat(absoluteUrl, ", status: ").concat(res.status, ", message: ").concat(message));
            return {
                error,
                type: "ApiError",
                code: res.status
            };
        }
        const error1 = new Error("failed to fetch ".concat(absoluteUrl, ", status: ").concat(res.status, ", json body, but no message, logging body."));
        console.error(body1);
        return {
            error: error1,
            type: "ApiError",
            code: res.status
        };
    } catch (e) {
        const error2 = new Error("failed to fetch ".concat(absoluteUrl, ", status: ").concat(res.status, ", no body."));
        return {
            error: error2,
            type: "ApiError",
            code: res.status
        };
    }
};
const fetchApiJsonTE = (apiDomain, url)=>pipe(()=>fetchApiJson(apiDomain, url), T.map((apiResult)=>"data" in apiResult ? E.right(apiResult.data) : E.left(apiResult)));

;// CONCATENATED MODULE: ./src/mainsite/api/fetchers.ts


const fetchers_fetchApiJson = (url)=>fetchApiJson(config/* getApiDomain */.A(), url);
const fetchers_fetchApiJsonTE = (url)=>fetchApiJsonTEShared(SharedConfig.getApiDomain(), url);
// Swr wants us to throw, but we don't like throwing, so we write code that
// doesn't throw, and add a wrapper for swr which does.
const fetchJsonSwr = async (url)=>{
    const dataOrError = await fetchers_fetchApiJson(url);
    if ("data" in dataOrError) {
        return dataOrError.data;
    } else {
        throw dataOrError.error;
    }
};


/***/ }),

/***/ 28835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useGaugeRates; }
/* harmony export */ });
/* unused harmony export fetchGaugeRates */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62523);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);




const url = "/api/v2/fees/gauge-rates";
const fetchGaugeRates = ()=>fetchApiJson(url);
const useGaugeRates = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(4)
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 16382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useMarketCaps; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5964);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);



const useMarketCaps = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("/api/fees/market-caps", _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: _duration__WEBPACK_IMPORTED_MODULE_2__/* .millisFromSeconds */ .Io(30)
    });
    return data;
};


/***/ }),

/***/ 99851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "It": function() { return /* binding */ useSupplySeriesCollections; }
});

// UNUSED EXPORTS: fetchSupplyOverTime, useSupplyOverTime

// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js
var secondsToMilliseconds = __webpack_require__(62523);
// EXTERNAL MODULE: ./node_modules/lodash/first.js
var first = __webpack_require__(8804);
var first_default = /*#__PURE__*/__webpack_require__.n(first);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
// EXTERNAL MODULE: ./src/mainsite/hardforks/paris.ts
var paris = __webpack_require__(62105);
// EXTERNAL MODULE: ./src/mainsite/hooks/use-pos-issuance-day.ts
var use_pos_issuance_day = __webpack_require__(25222);
;// CONCATENATED MODULE: ./src/mainsite/static-ether-data.ts
// amount in ETH, from: https://etherscan.io/chart/blockreward
const powIssuancePerDay = 13500;
const powIssuanceYear = powIssuancePerDay * 365.25;

// EXTERNAL MODULE: ./src/mainsite/time-frames.ts
var time_frames = __webpack_require__(78868);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/supply-over-time.ts











const url = "/api/v2/fees/supply-over-time";
const fetchSupplyOverTime = ()=>fetchApiJson(url);
const useSupplyOverTime = ()=>(0,dist/* default */.ZP)(url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    }).data;
const BITCOIN_SUPPLY_AT_MERGE = 19152350;
const BITCOIN_ISSUANCE_PER_TEN_MINUTES = 6.25;
const BITCOIN_ISSUANCE_PER_SECOND = BITCOIN_ISSUANCE_PER_TEN_MINUTES / (60 * 10);
const BITCOIN_HALVENING_SECONDS_AFTER_MERGE = 50347588; // Based on Halvening bitcoin block time of 2024-04-20T00:09:27
const BITCOIN_ISSUANCE_PER_SECOND_AFTER_HALVENING = BITCOIN_ISSUANCE_PER_SECOND / 2;
const SLOTS_PER_DAY = 24 * 60 * 5;
const calculateBitcoinIssuedSinceMerge = function(startTime, secondsDelta) {
    let result;
    if (startTime + secondsDelta < BITCOIN_HALVENING_SECONDS_AFTER_MERGE) {
        // Time frame ends before halfening - same logic as before
        result = secondsDelta * BITCOIN_ISSUANCE_PER_SECOND;
    } else if (startTime > BITCOIN_HALVENING_SECONDS_AFTER_MERGE) {
        // Time frame begins after halfening just change issuance rate
        result = secondsDelta * BITCOIN_ISSUANCE_PER_SECOND_AFTER_HALVENING;
    } else {
        // Time frame stretches across halfening, calculate issuance before and after halfening and add up
        result = (BITCOIN_HALVENING_SECONDS_AFTER_MERGE - startTime) * BITCOIN_ISSUANCE_PER_SECOND + (secondsDelta + startTime - BITCOIN_HALVENING_SECONDS_AFTER_MERGE) * BITCOIN_ISSUANCE_PER_SECOND_AFTER_HALVENING;
    }
    return result;
};
const btcSeriesFromPos = (ethPosSeries)=>{
    const ethPosFirstPointOption = (0,fp/* pipe */.zG)(ethPosSeries, fp.A.head);
    if (fp.O.isNone(ethPosFirstPointOption)) {
        return [
            [],
            []
        ];
    }
    const ethPosFirstPoint = ethPosFirstPointOption.value;
    const parisToTimeFrameSeconds = differenceInSeconds/* default */.Z(ethPosFirstPoint[0], paris/* MERGE_TIMESTAMP */.Hc);
    const firstPointBitcoinSupply = BITCOIN_SUPPLY_AT_MERGE + calculateBitcoinIssuedSinceMerge(0, parisToTimeFrameSeconds);
    const points = ethPosSeries.map((param)=>{
        let [timestamp] = param;
        const secondsDelta = ethPosFirstPoint[0] === undefined ? 0 : differenceInSeconds/* default */.Z(timestamp, ethPosFirstPoint[0]);
        const bitcoinIssued = calculateBitcoinIssuedSinceMerge(parisToTimeFrameSeconds, secondsDelta);
        const nextPoint = [
            timestamp,
            firstPointBitcoinSupply + bitcoinIssued
        ];
        return nextPoint;
    });
    const scalingConstant = ethPosFirstPoint[1] / firstPointBitcoinSupply;
    const pointsScaled = points.map((param)=>{
        let [timestamp, bitcoinSupply] = param;
        return [
            timestamp,
            bitcoinSupply * scalingConstant
        ];
    });
    return [
        points,
        pointsScaled
    ];
};
const powSeriesFromPos = (ethPosSeries, powMinPosIssuancePerDay, timeFrame)=>(0,fp/* pipe */.zG)(ethPosSeries, fp.A.filter((param)=>{
        let [timestamp] = param;
        return new Date(timestamp) >= paris/* MERGE_TIMESTAMP */.Hc;
    }), fp.A.map((param)=>{
        let [timestamp, supply] = param;
        const firstPoint = first_default()(ethPosSeries);
        // Map can only be called for points that are not undefined.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstPointTimestamp = new Date(firstPoint[0]);
        const slotsSinceStart = differenceInSeconds/* default */.Z(new Date(timestamp), firstPointTimestamp) / 12;
        const slotsSinceMerge = differenceInSeconds/* default */.Z(new Date(timestamp), paris/* MERGE_TIMESTAMP */.Hc) / 12;
        const slotCount = timeFrame === "since_burn" ? slotsSinceMerge : slotsSinceStart;
        const simulatedPowIssuanceSinceStart = slotCount / SLOTS_PER_DAY * powMinPosIssuancePerDay;
        const nextSupply = supply + simulatedPowIssuanceSinceStart;
        const nextPoint = [
            timestamp,
            nextSupply
        ];
        return nextPoint;
    }));
const supplyPointFromSupplyAtTime = (supplyAtTime)=>[
        new Date(supplyAtTime.timestamp).getTime(),
        supplyAtTime.supply
    ];
// We use four series to show supply over time. Three of which are derivatives
// of the first. As the response is currently rather large, containing an
// update for all time frames every block, even though 99% of the data is the
// same. We derive the other series from the first.
const useSupplySeriesCollections = ()=>{
    const supplyOverTimePerTimeFrame = useSupplyOverTime();
    const posIssuancePerDay = (0,use_pos_issuance_day/* usePosIssuancePerDay */.I)();
    // To compare proof of stake issuance to proof of work issuance we offer a
    // "simulate proof of work" toggle. However, we only have a supply series under
    // proof of stake. Already including proof of stake issuance. Adding proof of
    // work issuance would mean "simulated proof of work" is really what supply
    // would look like if there was both proof of work _and_ proof of stake
    // issuance. To make the comparison apples to apples we subtract an estimated
    // proof of stake issuance to show the supply as if there were _only_ proof of
    // work issuance. A possible improvement would be to drop this ad-hoc solution
    // and have the backend return separate series.
    const powMinPosIssuancePerDay = powIssuancePerDay - posIssuancePerDay;
    return (0,react.useMemo)(()=>(0,fp/* pipe */.zG)(supplyOverTimePerTimeFrame, fp.O.fromNullable, fp.O.map((supplyOverTimePerTimeFrame)=>(0,fp/* pipe */.zG)(// If only supply over time was a proper hashmap, we wouldn't need a complex zip here.
            time_frames/* timeFrames */.hN, fp.RA.toArray, fp.A.map((timeFrame)=>[
                    timeFrame,
                    supplyOverTimePerTimeFrame[timeFrame]
                ]), fp.A.map((param)=>{
                let [timeFrame, supplyOverTime] = param;
                const posSeries = (0,fp/* pipe */.zG)(supplyOverTime !== null && supplyOverTime !== void 0 ? supplyOverTime : [], fp.A.filter((supplyAtTime)=>supplyAtTime !== null && supplyAtTime !== undefined && supplyAtTime.timestamp !== undefined && supplyAtTime.supply !== undefined), fp.A.map(supplyPointFromSupplyAtTime));
                const powSeries = powSeriesFromPos(posSeries, powMinPosIssuancePerDay, timeFrame);
                const [btcSeries, btcSeriesScaled] = btcSeriesFromPos(posSeries);
                return [
                    timeFrame,
                    {
                        btcSeries,
                        btcSeriesScaled,
                        posSeries,
                        powSeries,
                        timestamp: supplyOverTimePerTimeFrame.timestamp
                    }
                ];
            }), (entries)=>fp/* Record.fromEntries */.WV.fromEntries(entries)))), [
        powMinPosIssuancePerDay,
        supplyOverTimePerTimeFrame
    ]);
};


/***/ }),

/***/ 43919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_D": function() { return /* binding */ useSupplyParts; },
/* harmony export */   "gC": function() { return /* binding */ useImpreciseEthSupply; },
/* harmony export */   "us": function() { return /* binding */ ethSupplyFromParts; }
/* harmony export */ });
/* unused harmony exports decodeEthSupply, impreciseEthSupplyFromParts, fetchSupplyParts, getEthSupplyImprecise */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11699);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39499);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsbi__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5964);
/* harmony import */ var _eth_units__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41492);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78051);








const decodeEthSupply = (supplyParts)=>({
        beaconBalancesSum: jsbi__WEBPACK_IMPORTED_MODULE_0___default().multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(supplyParts.beaconBalancesSum), _eth_units__WEBPACK_IMPORTED_MODULE_3__/* .WEI_PER_GWEI_JSBI */ .fk),
        beaconDepositsSum: jsbi__WEBPACK_IMPORTED_MODULE_0___default().multiply(jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(supplyParts.beaconDepositsSum), _eth_units__WEBPACK_IMPORTED_MODULE_3__/* .WEI_PER_GWEI_JSBI */ .fk),
        executionBalancesSum: jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(supplyParts.executionBalancesSum),
        slot: supplyParts.slot
    });
const ethSupplyFromParts = (supplyParts)=>jsbi__WEBPACK_IMPORTED_MODULE_0___default().subtract(jsbi__WEBPACK_IMPORTED_MODULE_0___default().add(supplyParts.executionBalancesSum, supplyParts.beaconBalancesSum), supplyParts.beaconDepositsSum);
const impreciseEthSupplyFromParts = (ethSupplyParts)=>{
    const ethSupplySum = ethSupplyFromParts(ethSupplyParts);
    return JSBI.toNumber(ethSupplySum) / WEI_PER_ETH;
};
const fetchSupplyParts = ()=>fetchApiJson("/api/v2/fees/supply-parts");
const useSupplyParts = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("/api/v2/fees/supply-parts", _fetchers__WEBPACK_IMPORTED_MODULE_4__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: _duration__WEBPACK_IMPORTED_MODULE_5__/* .millisFromSeconds */ .Io(4)
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return decodeEthSupply(data);
};
const useImpreciseEthSupply = ()=>{
    const ethSupply = useSupplyParts();
    const lastRefresh = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [lastEthSupply, setLastEthSupply] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ethSupply === undefined) {
            return undefined;
        }
        if (lastRefresh.current === undefined || date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z(new Date(), lastRefresh.current) > 60) {
            lastRefresh.current = new Date();
            setLastEthSupply(getEthSupplyImprecise(ethSupply));
        }
    }, [
        ethSupply
    ]);
    return lastEthSupply;
};
const getEthSupplyImprecise = (ethSupply)=>jsbi__WEBPACK_IMPORTED_MODULE_0___default().toNumber(jsbi__WEBPACK_IMPORTED_MODULE_0___default().subtract(jsbi__WEBPACK_IMPORTED_MODULE_0___default().add(ethSupply.executionBalancesSum, ethSupply.beaconBalancesSum), ethSupply.beaconDepositsSum)) / 1e18;


/***/ }),

/***/ 30772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BG": function() { return /* binding */ AmountBillionsUsdAnimated; },
/* harmony export */   "Ix": function() { return /* binding */ QuantifyTextAnimated; },
/* harmony export */   "au": function() { return /* binding */ AmountAnimatedShell; },
/* harmony export */   "fT": function() { return /* binding */ defaultMoneyAnimationDuration; },
/* harmony export */   "gn": function() { return /* binding */ AmountTrillionsUsdAnimated; },
/* harmony export */   "p7": function() { return /* binding */ PercentAmount; },
/* harmony export */   "qn": function() { return /* binding */ MoneyAmount; }
/* harmony export */ });
/* unused harmony export AmountCompactAnimated */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17857);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84849);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58739);
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12597);
/* harmony import */ var _Spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57845);
/* harmony import */ var _components_Texts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90917);
/* harmony import */ var _components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90079);
/* harmony import */ var _components_TextsNext_SkeletonText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7569);










const PercentAmount = (param)=>/*#__PURE__*/ {
    let { amountPostfix ="" , children , className , skeletonWidth ="3rem" , textSizeClass  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        amountPostfix: amountPostfix,
        className: className,
        size: textSizeClass !== null && textSizeClass !== void 0 ? textSizeClass : "text-base md:text-lg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_SkeletonText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            width: skeletonWidth,
            children: children
        })
    });
};
const MoneyAmount = (param)=>/*#__PURE__*/ {
    let { amountPostfix , children , className , skeletonWidth ="3rem" , textSizeClass , unitText ="ETH"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        amountPostfix: amountPostfix,
        className: className,
        unitPostfix: unitText,
        size: textSizeClass !== null && textSizeClass !== void 0 ? textSizeClass : "text-base md:text-lg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_SkeletonText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            width: skeletonWidth,
            children: children
        })
    });
};
const defaultMoneyAnimationDuration = 0.8;
const QuantifyTextAnimated = (param)=>/*#__PURE__*/ {
    let { children , decimals =2 , size , skeletonWidth , textClassName , unit , unitText  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AmountAnimatedShell, {
        size: size,
        skeletonWidth: skeletonWidth,
        textClassName: textClassName,
        unitText: unitText,
        children: children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            decimals: decimals,
            duration: defaultMoneyAnimationDuration,
            end: unit === "eth" ? _format__WEBPACK_IMPORTED_MODULE_4__/* .ethFromWei */ .zQ(children) : children,
            preserveValue: true,
            separator: ","
        })
    });
};
const AmountAnimatedShell = (param)=>{
    let { children , className ="" , color , size , skeletonWidth ="3rem" , textClassName ="" , tooltip , unitText  } = param;
    const { previewSkeletons  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_3__/* .FeatureFlagsContext */ .JN);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        color: color,
        size: size !== null && size !== void 0 ? size : "text-base md:text-lg",
        className: "whitespace-nowrap ".concat(textClassName, " ").concat(className),
        tooltip: tooltip,
        children: [
            children === undefined || previewSkeletons ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                width: skeletonWidth,
                inline: true
            }) : children,
            unitText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spacing__WEBPACK_IMPORTED_MODULE_5__/* .AmountUnitSpace */ .V, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Texts__WEBPACK_IMPORTED_MODULE_6__/* .UnitText */ .f4, {
                        children: unitText
                    })
                ]
            })
        ]
    });
};
const AmountBillionsUsdAnimated = (param)=>/*#__PURE__*/ {
    let { children , size , skeletonWidth ="3rem" , textClassName , tooltip  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AmountAnimatedShell, {
        size: size,
        skeletonWidth: skeletonWidth,
        textClassName: textClassName,
        tooltip: tooltip,
        unitText: "USD",
        children: children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            decimals: 2,
            duration: defaultMoneyAnimationDuration,
            end: children / 1e9,
            preserveValue: true,
            separator: ",",
            suffix: "B"
        })
    });
};
const AmountTrillionsUsdAnimated = (param)=>/*#__PURE__*/ {
    let { children , skeletonWidth ="3rem" , textClassName ="" , size  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AmountAnimatedShell, {
        skeletonWidth: skeletonWidth,
        textClassName: textClassName,
        size: size,
        unitText: "USD",
        children: children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            decimals: 2,
            duration: defaultMoneyAnimationDuration,
            end: children / 1e12,
            preserveValue: true,
            separator: ",",
            suffix: "T"
        })
    });
};
const AmountCompactAnimated = (param)=>/*#__PURE__*/ {
    let { children , size , skeletonWidth ="3rem" , textClassName ="" , unit ="eth"  } = param;
    return _jsx(AmountAnimatedShell, {
        size: size,
        skeletonWidth: skeletonWidth,
        textClassName: textClassName,
        unitText: unit === "eth" ? "ETH" : unit === "usd" ? "USD" : unit,
        children: children && /*#__PURE__*/ _jsx(CountUp, {
            duration: defaultMoneyAnimationDuration,
            end: children,
            preserveValue: true,
            separator: ",",
            formattingFn: Format.formatCompact
        })
    });
};


/***/ }),

/***/ 51508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const activePeriodClasses = "text-white border-slateus-400 rounded-sm bg-slateus-600";
const CurrencyButton = (param)=>/*#__PURE__*/ {
    let { onClick , selectedUnit , unit  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "\n      select-none border\n      px-3 py-2\n      font-roboto text-xs\n      font-normal uppercase\n      tracking-widest\n      ".concat(selectedUnit === unit ? activePeriodClasses : "border-transparent text-slateus-200"),
        onClick: ()=>onClick(unit),
        children: unit
    });
};
const CurrencyControl = (param)=>/*#__PURE__*/ {
    let { selectedUnit , onSetUnit  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-row items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurrencyButton, {
                onClick: onSetUnit,
                selectedUnit: selectedUnit,
                unit: "eth"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurrencyButton, {
                onClick: onSetUnit,
                selectedUnit: selectedUnit,
                unit: "usd"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrencyControl);


/***/ }),

/***/ 93964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FamTooltip; }
});

// UNUSED EXPORTS: ExternalLink

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/XMarkIcon.js
var XMarkIcon = __webpack_require__(51742);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/styles/Scrollbar.module.scss
var Scrollbar_module = __webpack_require__(23195);
var Scrollbar_module_default = /*#__PURE__*/__webpack_require__.n(Scrollbar_module);
// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/components/TextsNext/BodyText.tsx
var BodyText = __webpack_require__(68539);
// EXTERNAL MODULE: ./src/components/Twemoji.tsx
var Twemoji = __webpack_require__(63365);
// EXTERNAL MODULE: ./node_modules/twemoji/dist/twemoji.esm.js
var twemoji_esm = __webpack_require__(45623);
;// CONCATENATED MODULE: ./src/mainsite/components/Twitter/BioWithLinks.tsx


const getSortedLinkables = (linkables)=>{
    var ref, ref1, ref2, ref3;
    var ref4;
    const urlLinkables = (ref4 = (ref = linkables.urls) === null || ref === void 0 ? void 0 : ref.map((linkable)=>({
            ...linkable,
            type: "url"
        }))) !== null && ref4 !== void 0 ? ref4 : [];
    var ref5;
    const mentionLinkables = (ref5 = (ref1 = linkables.mentions) === null || ref1 === void 0 ? void 0 : ref1.map((linkable)=>({
            ...linkable,
            type: "mention"
        }))) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    const hashtagLinkables = (ref6 = (ref2 = linkables.hashtags) === null || ref2 === void 0 ? void 0 : ref2.map((linkable)=>({
            ...linkable,
            type: "hashtag"
        }))) !== null && ref6 !== void 0 ? ref6 : [];
    var ref7;
    const cashtagLinkables = (ref7 = (ref3 = linkables.cashtags) === null || ref3 === void 0 ? void 0 : ref3.map((linkable)=>({
            ...linkable,
            type: "cashtag"
        }))) !== null && ref7 !== void 0 ? ref7 : [];
    return [
        ...urlLinkables,
        ...mentionLinkables,
        ...hashtagLinkables,
        ...cashtagLinkables
    ].sort((l1, l2)=>l1.start < l2.start ? -1 : 1);
};
const buildBioElements = (bio, linkables)=>{
    // Linkable indices appear to assume a list of code points not UTF code units which JS uses by default.
    const bioCodePoints = Array.from(bio);
    const sortedLinkables = getSortedLinkables(linkables);
    const bioElements = [];
    let lastEndIndex = 0;
    for (const linkable of sortedLinkables){
        const text = bioCodePoints.slice(lastEndIndex, linkable.start);
        bioElements.push({
            type: "text",
            text
        });
        bioElements.push({
            type: linkable.type,
            linkable
        });
        lastEndIndex = linkable.end;
    }
    if (lastEndIndex !== bioCodePoints.length) {
        bioElements.push({
            type: "text",
            text: bioCodePoints.slice(lastEndIndex !== null && lastEndIndex !== void 0 ? lastEndIndex : 0)
        });
    }
    return bioElements;
};
// NOTE: using twemoji in the more safe dom parsing mode together with rapidly created and destroyed content resulted in crashes where somehow nodes from destroyed content would end up in newly created content, presumably because twemoji was keeping refs and directly updating the DOM. This would cause react to run into problems when trying in turn to update the DOM that had now changed out from under it. Using twemoji's string parsing mode seems to alleviate the issue.
const insertTwemoji = (str)=>twemoji_esm/* default.parse */.Z.parse(str, {
        className: "inline-block align-middle w-5 mb-1 ml-1",
        base: "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/"
    });
const BioWithLinks = (param)=>{
    let { bio , linkables  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: buildBioElements(bio, linkables).map((instruction, index)=>instruction.type === "text" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: insertTwemoji(instruction.text.join(""))
                }
            }, index) : instruction.type === "url" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "cursor-pointer text-slateus-200 hover:text-slateus-200 hover:underline",
                // href={instruction.linkable.expanded_url}
                onClick: (e)=>{
                    e.stopPropagation();
                    window.open(instruction.linkable.expanded_url, "_blank");
                },
                rel: "noreferrer",
                target: "_blank",
                children: instruction.linkable.display_url
            }, index) : instruction.type === "mention" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "cursor-pointer text-slateus-200 hover:text-slateus-200 hover:underline",
                // href={`https://twitter.com/${instruction.linkable.username}`}
                onClick: (e)=>{
                    e.stopPropagation();
                    window.open("https://twitter.com/".concat(instruction.linkable.username), "_blank");
                },
                rel: "noreferrer",
                target: "_blank",
                children: [
                    "@",
                    instruction.linkable.username
                ]
            }, index) : instruction.type === "hashtag" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "cursor-pointer text-slateus-200 hover:text-slateus-200 hover:underline",
                // href={`https://twitter.com/hashtag/${instruction.linkable.tag}`}
                onClick: (e)=>{
                    e.stopPropagation();
                    window.open("https://twitter.com/hashtag/".concat(instruction.linkable.tag), "_blank");
                },
                rel: "noreferrer",
                target: "_blank",
                children: [
                    "#",
                    instruction.linkable.tag
                ]
            }, index) : instruction.type === "cashtag" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "cursor-pointer text-slateus-200 hover:text-slateus-200 hover:underline",
                // href={`https://twitter.com/search?q=%24${instruction.linkable.tag}`}
                onClick: (e)=>{
                    e.stopPropagation();
                    window.open("https://twitter.com/search?q=%24".concat(instruction.linkable.tag), "_blank");
                },
                rel: "noreferrer",
                target: "_blank",
                children: [
                    "$",
                    instruction.linkable.tag
                ]
            }, index) : null)
    });
};
/* harmony default export */ var Twitter_BioWithLinks = (BioWithLinks);

// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
;// CONCATENATED MODULE: ./src/mainsite/components/FamTooltip.tsx











const ExternalLink = (param)=>{
    let { alt , className ="" , icon , href  } = param;
    const [isHovering, setIsHovering] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative cursor-pointer ".concat(className),
        onMouseEnter: ()=>setIsHovering(true),
        onMouseLeave: ()=>setIsHovering(false),
        onClick: (e)=>{
            e.stopPropagation();
            window.open(href, "_blank");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/round-".concat(icon, "-coloroff.svg"),
                alt: alt,
                className: "w-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "absolute top-0 w-12 ".concat(isHovering ? "" : "hidden"),
                src: "/round-".concat(icon, "-coloron.svg"),
                alt: alt
            })
        ]
    });
};
const Tooltip = (param)=>{
    let { coingeckoUrl , contractAddresses , description , famFollowerCount , followerCount , imageUrl , links , nftGoUrl , onClickClose , title , twitterUrl , width ="22rem"  } = param;
    // const [posX, setPosX] = useState<number | null>(null);
    // const [posY, setPosY] = useState<number | null>(null);
    // useEffect(() => {
    //   if (imageUrl !== undefined && getXAndY) {
    //     const { x, y } = getXAndY(imageUrl, sizeFactor);
    //     setPosX(x);
    //     setPosY(y);
    //   }
    // }, [getXAndY, imageUrl]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: "\n        relative\n        flex flex-col\n        gap-y-4 rounded-lg border\n        border-slateus-400 bg-slateus-700\n        p-8\n        ".concat(width, "\n      "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(XMarkIcon, {
                className: "absolute right-5 top-5 w-6 cursor-pointer select-none hover:brightness-90 active:brightness-110",
                onClick: onClickClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : "/leaderboard-images/question-mark-v2.svg",
                alt: "Fam image",
                width: 96,
                height: 96,
                className: "mx-auto h-20 w-20 select-none rounded-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                className: "font-semibold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twemoji/* default */.Z, {
                    imageClassName: "inline-block align-middle h-5 ml-1",
                    wrapper: true,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-h-64 overflow-y-auto ".concat((Scrollbar_module_default())["styled-scrollbar-horizontal"], " ").concat((Scrollbar_module_default())["styled-scrollbar-vertical"], " ").concat((Scrollbar_module_default())["styled-scrollbar"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                    className: "whitespace-pre-wrap md:leading-normal",
                    children: description === undefined ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter_BioWithLinks, {
                        bio: description,
                        linkables: links !== null && links !== void 0 ? links : {
                            cashtags: [],
                            hashtags: [],
                            mentions: [],
                            urls: []
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                children: "followers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                font: "font-roboto",
                                className: "text-2xl font-extralight",
                                children: followerCount === undefined ? "-" : format/* formatCompactOneDecimal */.Gb(followerCount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-end gap-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                children: "fam followers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                font: "font-roboto",
                                weight: "font-extralight",
                                className: "text-2xl",
                                children: famFollowerCount === undefined ? "-" : format/* formatZeroDecimals */.UY(famFollowerCount)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n        flex flex-col gap-y-4\n        ".concat(twitterUrl !== undefined || coingeckoUrl !== undefined || nftGoUrl !== undefined ? "block" : "hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                        children: "external links"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex select-none gap-x-4",
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                alt: "twitter logo",
                                className: "".concat(twitterUrl === undefined ? "hidden" : "block"),
                                href: twitterUrl,
                                icon: "twitter"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                alt: "coingecko logo",
                                className: "".concat(coingeckoUrl === undefined ? "hidden" : "block"),
                                href: coingeckoUrl,
                                icon: "coingecko"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                alt: "nftgo logo",
                                className: "".concat(nftGoUrl === undefined ? "hidden" : "block"),
                                href: nftGoUrl,
                                icon: "nftgo"
                            }),
                            contractAddresses !== undefined && contractAddresses// More than three and we might have trouble fitting everything.
                            .slice(0, 3).map((contractAddress)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                    alt: "etherscan logo",
                                    href: "https://etherscan.com/address/".concat(contractAddress),
                                    icon: "etherscan"
                                }, contractAddress))
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FamTooltip = (Tooltip);


/***/ }),

/***/ 56862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58739);
/* harmony import */ var _components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90917);





const Text = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .BaseText */ .k$, {
        font: "font-inter",
        color: "text-slateus-300",
        size: "text-xs",
        children: children
    });
};
const HoverTooltip = (param)=>{
    let { align ="right" , children , customAlign , position ="bottom" , text , zLevel ="z-20"  } = param;
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const featureFlags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlagsContext */ .JN);
    if (text === undefined || !featureFlags.showTooltips) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        onMouseOver: ()=>setShowTooltip(true),
        onMouseLeave: ()=>setShowTooltip(false),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "\n          absolute right-0 w-72\n          overflow-visible\n          rounded-lg border\n          border-slateus-400 bg-slateus-700\n          p-3 leading-4\n          ".concat(customAlign !== undefined ? customAlign : align === "right" ? "right-0" : "left-0", "\n          ").concat(position === "top" ? "bottom-8" : "top-8", "\n          ").concat(showTooltip ? "visible" : "hidden", "\n          ").concat(zLevel, "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    children: text
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HoverTooltip);


/***/ }),

/***/ 13852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ImageWithTooltip; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./src/assets/question-mark-v2.svg
/* harmony default export */ var question_mark_v2 = ({"src":"/_next/static/media/question-mark-v2.2a9991e1.svg","height":32,"width":32});
// EXTERNAL MODULE: ./src/feature-flags.ts
var feature_flags = __webpack_require__(58739);
;// CONCATENATED MODULE: ./src/mainsite/components/ImageWithTooltip.tsx






const ImageWithTooltip = (param)=>{
    let { className ="" , height , imageUrl , isDoneLoading =true , onClick , onMouseEnter , onMouseLeave , width  } = param;
    const imageRef = (0,react.useRef)(null);
    const { previewSkeletons  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    const [imgSrc, setImgSrc] = (0,react.useState)(imageUrl);
    const onImageError = (0,react.useCallback)(()=>{
        setImgSrc(question_mark_v2);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isDoneLoading || previewSkeletons ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "m-2 leading-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                circle: true,
                height: "".concat(height, "px"),
                width: "".concat(width, "px"),
                inline: true
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: imageRef,
            onMouseEnter: ()=>onMouseEnter === undefined ? undefined : onMouseEnter(imageRef),
            onMouseLeave: ()=>onMouseLeave === undefined ? undefined : onMouseLeave(imageRef),
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "\n              cursor-pointer\n              rounded-full active:brightness-125\n              md:cursor-auto md:active:brightness-100\n              ".concat(onMouseEnter !== undefined ? "hover:opacity-60" : "", "\n            "),
                src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : question_mark_v2,
                alt: "logo of an ERC20 token",
                onError: onImageError,
                onClick: onClick,
                width: width,
                height: height
            })
        })
    });
};
/* harmony default export */ var components_ImageWithTooltip = (ImageWithTooltip);


/***/ }),

/***/ 33181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Modal = (param)=>/*#__PURE__*/ {
    let { children , onClickBackground , show  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "\n      fixed top-0 left-0 bottom-0 right-0\n      z-20 flex items-center\n      justify-center\n      bg-slateus-600/60\n      ".concat(show ? "" : "hidden"),
        onClick: onClickBackground,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 57845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AmountUnitSpace; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const AmountUnitSpace = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "font-inter",
        children: "\xa0"
    });


/***/ }),

/***/ 62925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getFormattedDays; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89802);
/* harmony import */ var _components_TimeFrameControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5429);
/* harmony import */ var _dates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71119);
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5964);
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12597);
/* harmony import */ var _time_frames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78868);









const getFormattedDays = function(now, fork) {
    let bypassYears = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const daysCount = (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(now, fork);
    if (daysCount <= 365 || bypassYears) {
        return "".concat((0,_format__WEBPACK_IMPORTED_MODULE_5__/* .formatZeroDecimals */ .UY)(daysCount), "d");
    } else {
        const years = Math.floor(daysCount / 365);
        const days = daysCount % 365;
        return "".concat((0,_format__WEBPACK_IMPORTED_MODULE_5__/* .formatZeroDecimals */ .UY)(years), "y ").concat((0,_format__WEBPACK_IMPORTED_MODULE_5__/* .formatZeroDecimals */ .UY)(days), "d");
    }
};
const TimeFrameIndicator = (param)=>{
    let { className ="" , hideTimeFrameLabel , onClickTimeFrame , timeFrame  } = param;
    const [daysSinceLondon, setDaysSinceLondon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [daysSinceMerge, setDaysSinceMerge] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setDaysSinceLondon(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .londonHardFork */ .b9));
        setDaysSinceMerge(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .mergeDateTime */ .s_));
        const id = setTimeout(()=>{
            setDaysSinceLondon(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .londonHardFork */ .b9));
            setDaysSinceMerge(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .mergeDateTime */ .s_));
        }, (0,_duration__WEBPACK_IMPORTED_MODULE_8__/* .millisFromHours */ .QN)(1));
        return ()=>clearTimeout(id);
    }, []);
    const ContainerElement = onClickTimeFrame === undefined ? "div" : "button";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TimeFrameControl__WEBPACK_IMPORTED_MODULE_3__/* .LondonHardForkTooltip */ .G, {
        zLevel: "z-30",
        timeFrame: timeFrame,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContainerElement, {
            className: "\n          flex items-baseline gap-x-2\n          ".concat(onClickTimeFrame === undefined ? "" : "select-none hover:brightness-90 active:brightness-75", "\n          ").concat(className, "\n        "),
            onClick: onClickTimeFrame,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: hideTimeFrameLabel ? "hidden sm:block" : "block",
                    children: timeFrame === "since_burn" ? "since burn" : timeFrame === "since_merge" ? "since merge" : "time frame"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-roboto text-xs text-white",
                    children: timeFrame === "since_burn" ? daysSinceLondon : timeFrame === "since_merge" ? daysSinceMerge : _time_frames__WEBPACK_IMPORTED_MODULE_6__/* .displayLimitedTimeFrameMap */ .I1[timeFrame]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimeFrameIndicator);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11699);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23855);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69690);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58739);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89802);
/* harmony import */ var _components_TextsNext_SkeletonText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7569);
/* harmony import */ var _components_TextsNext_LabelUnitText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76688);








const UpdatedAge = (param)=>{
    let { updatedAt  } = param;
    const featureFlags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlagsContext */ .JN);
    const [timeElapsed, setTimeElapsed] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (updatedAt === undefined) {
            return;
        }
        const secs = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(), (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(updatedAt));
        const mins = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(), (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(updatedAt));
        setTimeElapsed({
            secs,
            mins
        });
        const intervalId = window.setInterval(()=>{
            const secs = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(), (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(updatedAt));
            const mins = (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(), (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(updatedAt));
            setTimeElapsed({
                secs,
                mins
            });
        }, 1000);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        updatedAt
    ]);
    const secsOrMins = timeElapsed === undefined || featureFlags.previewSkeletons ? undefined : timeElapsed.secs >= 60 ? timeElapsed.mins : timeElapsed.secs;
    const postfixLarge = timeElapsed === undefined ? undefined : (timeElapsed === null || timeElapsed === void 0 ? void 0 : timeElapsed.secs) >= 60 ? timeElapsed.mins === 1 ? "minute" : "minutes" : "seconds";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-x-1 items-baseline truncate",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "text-slateus-400",
                children: "updated"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelUnitText__WEBPACK_IMPORTED_MODULE_5__/* .LabelUnitText */ .B, {
                className: "-mr-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_SkeletonText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    width: "4.5rem",
                    children: secsOrMins
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "ml-1",
                children: postfixLarge
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "text-slateus-400",
                className: "truncate",
                children: "ago"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UpdatedAge);


/***/ }),

/***/ 146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contexts_TranslationsContext; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./locales/en/data.json
var data_namespaceObject = JSON.parse('{"title":"ultrasound.money","main_title":"EIP-1559 activation","meta_description":"watch ETH become ultra sound money","meta_keywords":"ultra sound money, ethereum, ETH, sound money, fee burn, EIP-1559","og_url":"https://ultrasound.money","og_img":"https://gateway.pinata.cloud/ipfs/QmVpSMAAnWx7vDcL4LxwiBDmmRjC1jiVUheVFTNzcUNxvx","title_countdown":"fork block","title_current_block":"current block","title_remaning_block":"remaining blocks","countdownNr":"12965000","title_community":"join #XXX fam members","title_community_hover":"join the ultra sound Twitter fam","description_community_1":"wear ","description_community_2":" on your Twitter name or profile","click_to_join":"click to join...","profile_follower":"Followers","landing_hero_title":"ETH is becoming","landing_dashboard_link":"Dashboard","landing_faq_link":"FAQ","landing_hero_title_1":"Ultra Sound Money","landing_before_genesis_title":"Before we get into Ultra Sound Money, let’s talk about how we got here","landing_before_genesis_text":"Section for brief historical events and current ETH state to set the scene for Ultrasound money. Graphics, Light data and simple carts","landing_genesis_date":"block 0, Jul 31, 2015","landing_genesis_title":"Ethereum  Genesis","landing_genesis_text":"Ethereum is open access to digital money and data-friendly services for everyone – no matter your background or location. It\'s a community-built technology behind the cryptocurrency ether (ETH)","landing_genesis_card_name":"Jul 31, 2015","landing_genesis_card_title":"inflationary","landing_genesis_card2_name":"ETH supply","landing_genesis_card2_title":"72M","landing_genesis_card2_title1":"↑+5.3%","landing_genesis_card3_name":"block reward","landing_genesis_card3_title":"3 ETH/<span>block</span>","landing_byzantium_date":"block 4,370,000, Oct 16, 2017","landing_byzantium_title":"EIP Byzantium","landing_byzantium_text":"<span class=\\"text-white\\">EIP (Ethereum Improvement Proposal)</span> is open access to digital money and data-friendly services for everyone – no matter your background or location. It\'s a community-built technology behind the cryptocurrency ether (ETH)","landing_byzantium_card_name":"Oct 16, 2017","landing_byzantium_card_title":"inflationary","landing_byzantium_card2_name":"ETH supply","landing_byzantium_card2_title":"72M","landing_byzantium_card2_title1":"↑+5.3%","landing_byzantium_card3_name":"block reward","landing_byzantium_card3_title":"3 ETH/<span>block</span>","landing_constantinopole_date":"block 4,370,000, Oct 16, 2017","landing_constantinopole_title":"EIP Constantinopole","landing_constantinopole_text":"<span class=\\"text-white\\">EIP (Ethereum Improvement Proposal)</span> is open access to digital money and data-friendly services for everyone – no matter your background or location. It\'s a community-built technology behind the cryptocurrency ether (ETH)","landing_constantinopole_card_name":"Oct 16, 2017","landing_constantinopole_card_title":"inflationary","landing_constantinopole_card2_name":"ETH supply","landing_constantinopole_card2_title":"72M","landing_constantinopole_card2_title1":"↑+5.3%","landing_constantinopole_card3_name":"block reward","landing_constantinopole_card3_title":"3 ETH/<span>block</span>","landing_eip1559_title":"EIP 1559 aka (The Fee 🔥 Burn)","landing_eip1559_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud e ","landing_goal_title":"It’ Goals?","landing_goal_block1_icon":"🔭","landing_goal_block1_title":"Predictable Transaction Fees","landing_goal_block1_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt","landing_goal_block2_icon":"🚀","landing_goal_block2_title":"Reduced Delays","landing_goal_block2_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt","landing_goal_block3_icon":"😃","landing_goal_block3_title":"Improved User Experience","landing_goal_block3_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt","landing_feeburned_card1_name":"status Jul 31, 2015","landing_feeburned_card1_title":"inflationary","landing_feeburned_card2_name":"ETH supply","landing_feeburned_card2_title":"72M","landing_feeburned_card2_title1":"↑+5.3%","landing_feeburned_card3_name":"block reward","landing_feeburned_card3_title":"3 ETH/Block","landing_feeburned_card4_name":"fees burned 🔥","landing_feeburned_card4_title":"$314.55","landing_themerge_title":"What\'s Next?","landing_themerge_text":"\\"The Merge\\" is an upgrade to Ethereum that swaps out the current proof-of-work (PoW) consensus mechanism with a more eco-friendly, efficient, and secure proof-of-stake (PoS) consensus mechanism.","landing_themerge_pow_icon":"🏭 ⚡","landing_themerge_pow_title":"Proof of Work","landing_themerge_pow_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt","landing_themerge_pos_icon":"🌿","landing_themerge_pos_title":"Proof of Stake","landing_themerge_pos_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt","landing_themerge_title2":"The Merge. Hello PoS, so long PoW","landing_themerge_text2":"\\"The Merge\\" is an upgrade to Ethereum that swaps out the current proof-of-work (PoW) consensus mechanism with a more eco-friendly, efficient, and secure proof-of-stake (PoS) consensus mechanism","title_following_you":"me & the fam","teaser_following_you":"do we know each other? find out how many of us follow you.","dashboard_title":"dashboard","chart_thousands_sep":",","chart_decimal_point":".","### ETH supply graph component ###":true,"eth_staked":"staking amount","base_gas_price":"base gas price (average)","merge_date":"merge date","pos_issuance":"PoS issuance","fee_burn":"fee burn","pow_removal":"PoW removal","projected":"projected","projected_supply":"projected supply","historical_supply":"historical supply","peak_supply":"supply peak","supply_chart_series_address":"in accounts","supply_chart_series_contracts":"in contracts","supply_chart_series_staking":"in validators","supplu_chart_title":"an ultra sound supply curve?","sypply_chart_description":"Lorem ipsum dolor sit amet, consectetur <br/> adipiscing elit, sed do eiusmod tempor incididunt <br/> Lorem ipsum dolor sit amet, consect.","sypply_chart_button":"explore the data","marker_genesis":"genesis","marker_phase_0":"phase 0","marker_merge":"merge","marker_pos":"staking","marker_pow_removal":"PoW removal","marker_block":"block","total_supply":"total supply","eth_supply":"ETH supply","eth_per_day":"ETH/day","numeric_billion_abbrev":"B","numeric_million_abbrev":"M","numeric_thousand_abbrev":"K","time_range_all":"all","time_range_1y":"1y","time_range_6mo":"6mo","time_range_30d":"30d","time_range_7d":"7d","time_range_1d":"1d","title_nft_drop":"nft drop","description_nft_drop":"The activation of EIP-1559 institutes a big change. A change met with excitement by an ever-growing number of people. What better way to celebrate this milestone than with a laugh, a cheer, and a gorgeous NFT.","faq_question_1":"What is ultra sound money?","faq_answer_1":"Ultra sound money is an Ethereum meme focusing on the likely decrease of the ETH supply.\\n\\nIf capped-supply gold is sound, decreasing-supply ether is ultra sound.","faq_question_2":"How can ETH supply decrease?","faq_answer_2":"The ETH supply decreases whenever more ETH is destroyed via fee burn than ETH is created via issuance.\\n\\nFee burn is a scarcity engine fuelled by Ethereum\'s transactional utility.","faq_question_3":"What is fee burn?","faq_answer_3":"Fee burn is a mechanism which destroys ETH base fees paid for transaction inclusion on Ethereum.\\n\\nFee burn started August 5, 2021 with the activation of <a href=\\"https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1559.md\\">EIP-1559</a>.","faq_question_4":"What are base fees?","faq_answer_4":"Base fees are protocol-quoted minimum fees for transaction inclusion in an Ethereum block.\\n\\nPriority fees paid in addition to base fees are not burned.","faq_question_5":"When will ETH be ultra sound?","faq_answer_5":"The ETH supply will likely decrease when PoW issuance is removed, leaving only PoS issuance.\\n\\nThe removal of PoW will happen at the merge, likely Q3 2022.","faq_question_6":"What is the merge?","faq_answer_6":"The merge (see <a href=\\"https://github.com/ethereum/EIPs/pull/3675\\">EIP-3675</a>) is the hot-swapping of issuance-heavy PoW for issuance-light PoS.\\n\\nThe merge will cause an issuance shock called the triple halvening.","faq_question_7":"What is the triple halvening?","faq_answer_7":"The triple halvening is an issuance cliff roughly equivalent to three Bitcoin halvenings.\\n\\nAt the merge total issuance drops from ~15K ETH/day to ~1.5K ETH/day.","faq_question_8":"What are the origins of the meme?","faq_answer_8":"<span class=\\"mono\\"><a href=\\"https://www.youtube.com/watch?v=47Z4ZpBiTwA&t=1770s\\">Aug 2020</a></span>—Vitalik Buterin jokes about supersonic money\\n<span class=\\"mono\\"><a href=\\"https://twitter.com/drakefjustin/status/1304064879662227456\\">Sep 2020</a></span>—Justin Drake memes about ultrasound money\\n<span class=\\"mono\\"><a href=\\"https://www.youtube.com/watch?v=bWqhn1hXvVc\\">Mar 2021</a></span>—Bankless popularizes ultra sound money","faq_question_9":"What is the bat signal 🦇🔊?","faq_answer_9":"The bat signal is a visual expression of the ultra sound money meme, a playful nod to bat ultrasounds.\\n\\nThe ultra sound fam wears the bat signal to spread the meme.","eusm_section_title":"Enter The Ultra Sound Money","eusm_row_1_left_col_title":"WTF is an Ultra Sound Money <br> and why should I even care","eusm_row_1_left_col_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate","eusm_row_1_right_col_title":"ETH - Deflationary","eusm_row_1_right_col_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.","eusm_row_2_title":"ETH - Ultrasound Money","eusm_row_2_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate ","eusm_row_3_title":"BTC - Sound Money - Inflationary","eusm_row_3_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate ","eusm_row_4_title":"USD - Un-Sound Money - Inflationary","eusm_row_4_text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate "}');
;// CONCATENATED MODULE: ./src/mainsite/contexts/TranslationsContext.ts


const TranslationsContext = react.createContext(data_namespaceObject);
/* harmony default export */ var contexts_TranslationsContext = (TranslationsContext);


/***/ }),

/***/ 62105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ MERGE_TIMESTAMP; },
/* harmony export */   "yO": function() { return /* binding */ MERGE_SUPPLY; }
/* harmony export */ });
/* unused harmony exports MERGE_BLOCK_NUMBER, TOTAL_TERMINAL_DIFFICULTY */
const MERGE_BLOCK_NUMBER = 15537394;
const MERGE_SUPPLY = 120521140.9246213;
const MERGE_TIMESTAMP = new Date("2022-09-15T06:42:59Z");
const TOTAL_TERMINAL_DIFFICULTY = 5.875e22;


/***/ }),

/***/ 25222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ usePosIssuancePerDay; }
/* harmony export */ });
/* harmony import */ var _time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34614);
/* harmony import */ var _api_gauge_rates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28835);


const usePosIssuancePerDay = ()=>(0,_api_gauge_rates__WEBPACK_IMPORTED_MODULE_1__/* .useGaugeRates */ .f)().d7.issuance_rate_yearly.eth / _time__WEBPACK_IMPORTED_MODULE_0__/* .DAYS_PER_YEAR */ ._G;


/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I1": function() { return /* binding */ displayLimitedTimeFrameMap; },
/* harmony export */   "SV": function() { return /* binding */ getPreviousTimeFrame; },
/* harmony export */   "hN": function() { return /* binding */ timeFrames; },
/* harmony export */   "z9": function() { return /* binding */ getNextTimeFrame; }
/* harmony export */ });
/* unused harmony exports limitedTimeFrames, timeFramesOld, getNextTimeFrameOld */
const limitedTimeFrames = [
    "m5",
    "h1",
    "d1",
    "d7",
    "d30"
];
/** @deprecated use timeFrames instead, with an API map to convert to/from legacy time frames. */ const timeFramesOld = (/* unused pure expression or super */ null && ([
    "m5",
    "h1",
    "d1",
    "d7",
    "d30",
    "all"
]));
const displayLimitedTimeFrameMap = {
    m5: "5m",
    h1: "1h",
    d1: "1d",
    d7: "7d",
    d30: "30d"
};
const getNextTimeFrameOld = (timeFrame)=>{
    const nextIndex = (timeFramesOld.indexOf(timeFrame) + 1) % timeFramesOld.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFramesOld[nextIndex];
};
// We care about the order here. since_merge first then since_burn, therefore
const timeFrames = [
    ...limitedTimeFrames,
    "since_merge",
    "since_burn"
];
const getNextTimeFrame = (timeFrame)=>{
    const nextIndex = (timeFrames.indexOf(timeFrame) + 1) % timeFrames.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFrames[nextIndex];
};
const getPreviousTimeFrame = (timeFrame)=>{
    const currentIndex = timeFrames.indexOf(timeFrame);
    const previousIndex = (currentIndex + timeFrames.length - 1) % timeFrames.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFrames[previousIndex];
};


/***/ }),

/***/ 95251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useActiveBreakpoint; }
/* harmony export */ });
/* harmony import */ var _react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84990);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


// Try not to use this, it forces JS to react to breakpoints instead of the usual CSS. This may cause SSR issues.
const useActiveBreakpoint = ()=>{
    const [activeBreakpoints, setActiveBreakpoints] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xl2: false
    });
    const sm = (0,_react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__/* .useMediaQuery */ .a)("(min-width: 640px)");
    const md = (0,_react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__/* .useMediaQuery */ .a)("(min-width: 768px)");
    const lg = (0,_react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__/* .useMediaQuery */ .a)("(min-width: 1024px)");
    const xl = (0,_react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__/* .useMediaQuery */ .a)("(min-width: 1280px)");
    const xl2 = (0,_react_hook_media_query__WEBPACK_IMPORTED_MODULE_1__/* .useMediaQuery */ .a)("(min-width: 1536px)");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setActiveBreakpoints({
            sm,
            md,
            lg,
            xl,
            xl2
        });
    }, [
        sm,
        md,
        lg,
        xl,
        xl2
    ]);
    return activeBreakpoints;
};


/***/ }),

/***/ 64467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/components/BasicErrorBoundary.tsx
var BasicErrorBoundary = __webpack_require__(46756);
// EXTERNAL MODULE: ./node_modules/jsbi/dist/jsbi-umd.js
var jsbi_umd = __webpack_require__(39499);
var jsbi_umd_default = /*#__PURE__*/__webpack_require__.n(jsbi_umd);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var react_loading_skeleton_dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(36860);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/components/HeaderGlow/index.tsx + 1 modules
var HeaderGlow = __webpack_require__(42857);
// EXTERNAL MODULE: ./src/components/MainTitle/index.tsx
var MainTitle = __webpack_require__(6523);
// EXTERNAL MODULE: ./src/eth-units.ts
var eth_units = __webpack_require__(41492);
// EXTERNAL MODULE: ./src/feature-flags.ts
var feature_flags = __webpack_require__(58739);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/sections/ContactSection/index.tsx + 5 modules
var ContactSection = __webpack_require__(48613);
// EXTERNAL MODULE: ./src/mainsite/time-frames.ts
var time_frames = __webpack_require__(78868);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js
var secondsToMilliseconds = __webpack_require__(62523);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
;// CONCATENATED MODULE: ./src/mainsite/api/base-fee-per-gas.ts




const url = "/api/v2/fees/base-fee-per-gas";
const fetchBaseFeePerGas = ()=>fetchApiJsonTE(url);
const useBaseFeePerGas = ()=>{
    const { data  } = (0,dist/* default */.ZP)(url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4),
        refreshWhenHidden: true
    });
    return fp.O.fromNullable(data);
};

// EXTERNAL MODULE: ./src/mainsite/api/eth-price-stats.ts
var eth_price_stats = __webpack_require__(92679);
// EXTERNAL MODULE: ./src/mainsite/api/supply-parts.ts
var supply_parts = __webpack_require__(43919);
// EXTERNAL MODULE: ./src/components/Accordion/index.tsx
var Accordion = __webpack_require__(82770);
// EXTERNAL MODULE: ./src/mainsite/contexts/TranslationsContext.ts + 1 modules
var TranslationsContext = __webpack_require__(146);
// EXTERNAL MODULE: ./src/components/TextsNext/SectionTitle.tsx
var SectionTitle = __webpack_require__(44759);
// EXTERNAL MODULE: ./src/contexts/NavigationContext.tsx
var NavigationContext = __webpack_require__(47387);
;// CONCATENATED MODULE: ./src/mainsite/components/Faq.tsx






const calcCenterElement = (element)=>{
    const topEl = element.getBoundingClientRect().y + window.scrollY;
    const heightEl = element.clientHeight;
    // like {top: 50%, transform: translateY(-50%)} in CSS
    return topEl - window.innerHeight / 2 + heightEl / 2;
};
const FaqBlock = ()=>{
    const t = react.useContext(TranslationsContext/* default */.Z);
    const { changeFaqPosition  } = react.useContext(NavigationContext/* NavigationContext */.k);
    const faqSection = react.useRef(null);
    react.useEffect(()=>{
        const resizeFun = ()=>{
            if (faqSection.current) {
                const centerBlock = calcCenterElement(faqSection.current);
                changeFaqPosition(centerBlock);
            }
        };
        resizeFun();
        window.addEventListener("resize", resizeFun);
        return ()=>window.removeEventListener("resize", resizeFun);
    }, [
        changeFaqPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: faqSection,
        "data-aos": "fade-up",
        "data-aos-anchor-placement": "top-center",
        "data-aos-delay": "50",
        "data-aos-duration": "1000",
        "data-aos-easing": "ease-in-out",
        id: "faq",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-3xl md:px-4 md:m-auto lg:px-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "block py-32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        children: "q&a"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 w-full md:px-8 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_1,
                            text: t.faq_answer_1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_2,
                            text: t.faq_answer_2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_3,
                            text: t.faq_answer_3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_4,
                            text: t.faq_answer_4
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_6,
                            text: t.faq_answer_6
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_7,
                            text: t.faq_answer_7
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_8,
                            text: t.faq_answer_8
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full bg-slateus-400",
                            style: {
                                height: "1px",
                                opacity: "0.3"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                            title: t.faq_question_9,
                            text: t.faq_answer_9
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Faq = (FaqBlock);

// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./src/mainsite/hooks/use-local-storage.ts

const useLocalStorage = (key, initialValue)=>{
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = (0,react.useState)(()=>{
        if (false) {}
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            console.log(error);
            return initialValue;
        }
    });
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value)=>{
        if (false) {}
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };
    return [
        storedValue,
        setValue
    ];
};

;// CONCATENATED MODULE: ./src/mainsite/hooks/use-notification.ts

const getIsMobile = ()=>{
    if (typeof navigator === "undefined") {
        return false;
    }
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const useNotification = ()=>{
    const [isNotificationSupported, setIsNotificationSupported] = (0,react.useState)();
    const [permission, setPermission] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if ( false || !("Notification" in window) || getIsMobile()) {
            setIsNotificationSupported(false);
            return undefined;
        }
        setIsNotificationSupported(true);
        setPermission(Notification.permission);
    }, []);
    // Notification permission may change without this component rerendering, to catch that we periodically check.
    (0,react.useEffect)(()=>{
        if (!isNotificationSupported) {
            return undefined;
        }
        const id = setInterval(()=>{
            if (permission !== Notification.permission) {
                setPermission(Notification.permission);
            }
        }, 2000);
        return ()=>clearInterval(id);
    });
    const requestPermission = (0,react.useCallback)(async ()=>{
        if (!isNotificationSupported) {
            return undefined;
        }
        const permission = await Notification.requestPermission();
        setPermission(permission);
    }, [
        isNotificationSupported
    ]);
    const showNotification = (0,react.useCallback)((title, body)=>{
        if (permission !== "granted") {
            return;
        }
        new Notification(title, {
            body
        });
    }, [
        permission
    ]);
    const notificationState = (0,react.useMemo)(()=>{
        if (!isNotificationSupported || permission === undefined) {
            return {
                type: "Unsupported"
            };
        }
        return {
            type: "Supported",
            permission: permission,
            requestPermission,
            showNotification
        };
    }, [
        isNotificationSupported,
        permission,
        requestPermission,
        showNotification
    ]);
    return notificationState;
};
/* harmony default export */ var use_notification = (useNotification);

// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./node_modules/lodash/replace.js
var replace = __webpack_require__(13880);
var replace_default = /*#__PURE__*/__webpack_require__.n(replace);
// EXTERNAL MODULE: ./src/components/ToggleSwitch.tsx
var ToggleSwitch = __webpack_require__(71122);
// EXTERNAL MODULE: ./src/mainsite/components/Spacing.tsx
var Spacing = __webpack_require__(57845);
// EXTERNAL MODULE: ./src/mainsite/components/TopBar/AlarmInput.module.scss
var AlarmInput_module = __webpack_require__(60146);
var AlarmInput_module_default = /*#__PURE__*/__webpack_require__.n(AlarmInput_module);
;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/eth-slateus.svg
/* harmony default export */ var eth_slateus = ({"src":"/_next/static/media/eth-slateus.4ac61d8c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/gas-slateus.svg
/* harmony default export */ var gas_slateus = ({"src":"/_next/static/media/gas-slateus.08e75f71.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/AlarmInput.tsx

















const thresholdToNumber = (threshold)=>{
    if (threshold === undefined) {
        return undefined;
    }
    const num = Number(replace_default()(threshold, ",", ""));
    return Number.isNaN(num) ? undefined : num;
};
const safeFormatZeroDigit = (num)=>num === undefined ? undefined : (0,format/* formatZeroDecimals */.UY)(num);
const toThresholdDisplay = (str)=>safeFormatZeroDigit(thresholdToNumber(str));
const compareMap = {
    GreaterThanOrEqualTo: (current, limit)=>current >= limit,
    SmallerThan: (current, limit)=>current < limit
};
const typeToDisplay = (type)=>type === "eth" ? "ETH" : type;
const imageMap = {
    gas: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: gas_slateus,
        width: "14",
        height: "14",
        alt: "gas pump icon"
    }),
    eth: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: eth_slateus,
        alt: "Ethereum Ether icon",
        width: "16",
        height: "16"
    })
};
const AlarmInput = (param)=>{
    let { isAlarmActive , onToggleIsAlarmActive , type , unit  } = param;
    const baseFeePerGas = useBaseFeePerGas();
    const ethPriceStats = (0,eth_price_stats/* useEthPriceStats */.U)();
    const notification = use_notification();
    const [isBusyEditing, setIsBusyEditing] = (0,react.useState)(false);
    const [threshold, setThreshold] = useLocalStorage("".concat(type, "-threshold"), "0");
    const [thresholdType, setThresholdType] = useLocalStorage("".concat(type, "-threshold-type"), "GreaterThanOrEqualTo");
    const inputRef = (0,react.useRef)(null);
    const roundedGasPriceGwei = (0,fp/* pipe */.zG)(baseFeePerGas, fp.O.map((baseFeePerGas)=>Math.round(baseFeePerGas.wei / eth_units/* WEI_PER_GWEI */.c1)), fp.O.toUndefined);
    const roundedEthPrice = ethPriceStats === undefined ? undefined : Math.round(ethPriceStats.usd);
    const currentValueMap = {
        gas: roundedGasPriceGwei,
        eth: roundedEthPrice
    };
    const currentValue = currentValueMap[type];
    const thresholdNum = thresholdToNumber(threshold);
    const handleSetThreshold = (0,react.useCallback)((event)=>{
        // Should never happen, the parent should disable the dialog altogether in this case.
        if (currentValue === undefined) {
            return;
        }
        const inputThresholdNum = thresholdToNumber(event.target.value);
        if (inputThresholdNum === undefined) {
            return undefined;
        }
        if (event.target.value.length > 6) {
            return undefined;
        }
        if (inputThresholdNum >= currentValue) {
            setThresholdType("GreaterThanOrEqualTo");
        } else {
            setThresholdType("SmallerThan");
        }
        setIsBusyEditing(true);
        setThreshold(event.target.value);
    }, [
        currentValue,
        setThreshold,
        setThresholdType
    ]);
    const handleDoneEditing = (0,react.useCallback)(()=>{
        setIsBusyEditing(false);
    }, [
        setIsBusyEditing
    ]);
    const handleToggleIsAlarmActive = (0,react.useCallback)((nextIsAlarmActive)=>{
        // Should never happen, the parent should disable the dialog altogether in this case.
        if (currentValue === undefined) {
            return undefined;
        }
        if (notification.type !== "Supported" || notification.permission === "denied") {
            return undefined;
        }
        if (notification.permission === "default") {
            notification.requestPermission().catch((err)=>{
                throw err;
            });
            return;
        }
        const inputThresholdNum = thresholdToNumber(threshold);
        if (inputThresholdNum === undefined) {
            return undefined;
        }
        if (inputThresholdNum >= currentValue) {
            setThresholdType("GreaterThanOrEqualTo");
        } else {
            setThresholdType("SmallerThan");
        }
        onToggleIsAlarmActive(nextIsAlarmActive);
    }, [
        currentValue,
        notification,
        onToggleIsAlarmActive,
        setThresholdType,
        threshold
    ]);
    (0,react.useEffect)(()=>{
        // It's possible someone changed this in another tab and we haven't yet read this from local storage. To make sure we have the latest value we read local storage again. This key is currently hardcoded to match the one in the parent that ows this piece of state.
        const isAlarmActiveLocalStorage = localStorage.getItem("".concat(type, "-alarm-enabled"));
        const isAlarmActiveSynced = isAlarmActiveLocalStorage === null ? false : JSON.parse(isAlarmActiveLocalStorage);
        onToggleIsAlarmActive(isAlarmActiveSynced);
        if (notification.type === "Supported" && notification.permission === "granted" && isAlarmActiveSynced && typeof currentValue === "number" && typeof thresholdNum === "number" && !isBusyEditing) {
            const crossedThresholdFn = compareMap[thresholdType];
            const isThresholdCrossed = crossedThresholdFn(currentValue, thresholdNum);
            if (!isThresholdCrossed) {
                return undefined;
            }
            const typeFormatted = typeToDisplay(type);
            const currentValueFormatted = (0,format/* formatZeroDecimals */.UY)(currentValue);
            const message = "".concat(typeFormatted, " price hit ").concat(currentValueFormatted, " ").concat(unit.trimEnd());
            notification.showNotification(message);
            onToggleIsAlarmActive(false);
        }
    }, [
        currentValue,
        isAlarmActive,
        isBusyEditing,
        notification,
        onToggleIsAlarmActive,
        roundedGasPriceGwei,
        thresholdNum,
        thresholdType,
        type,
        unit
    ]);
    const handleSurroundingInputClick = (0,react.useCallback)(()=>{
        if (inputRef.current === null) {
            return undefined;
        }
        inputRef.current.focus();
    }, [
        inputRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-center pt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex select-none items-center justify-between rounded-full border border-gray-500 px-2 py-1 pr-4 ".concat((AlarmInput_module_default()).alarmInput),
                onClick: handleSurroundingInputClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center ml-1 w-5",
                        children: imageMap[type]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                ref: inputRef,
                                className: "\n              w-14 bg-transparent\n              text-right\n              font-roboto\n              text-sm font-light text-white\n              focus:outline-none\n            ",
                                inputMode: "numeric",
                                pattern: "[0-9]",
                                value: toThresholdDisplay(threshold),
                                onChange: handleSetThreshold,
                                onBlur: handleDoneEditing
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                font: "font-roboto",
                                weight: "font-extralight",
                                color: "text-slateus-200",
                                className: "text-sm whitespace-pre",
                                children: unit
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch/* default */.Z, {
                checked: isAlarmActive,
                onToggle: handleToggleIsAlarmActive
            })
        ]
    });
};
/* harmony default export */ var TopBar_AlarmInput = (AlarmInput);

;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/bell-slateus.svg
/* harmony default export */ var bell_slateus = ({"src":"/_next/static/media/bell-slateus.8807504f.svg","height":100,"width":100});
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./src/components/TextsNext/SkeletonText.tsx
var SkeletonText = __webpack_require__(7569);
// EXTERNAL MODULE: ./src/mainsite/api/barrier.ts
var api_barrier = __webpack_require__(84450);
;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/PriceGasWidget.tsx















const PriceGasBoundary = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n          rounded-lg border border-red-400 bg-slateus-700 px-4 py-2 text-center\n          font-roboto\n          text-xs text-white\n        ",
            children: "gas / price widget crashed"
        }),
        children: children
    });
};
const PriceGasWidget = ()=>{
    const baseFeePerGas = useBaseFeePerGas();
    const barrier = (0,api_barrier/* useBaseFeePerGasBarrier */.K)().barrier * eth_units/* WEI_PER_GWEI */.c1;
    const ethPriceStats = (0,eth_price_stats/* useEthPriceStats */.U)();
    const ethUsd24hChange = ethPriceStats === undefined ? undefined : format/* formatPercentOneDecimalSigned */.W3(ethPriceStats.h24Change);
    const color = ethPriceStats === undefined ? undefined : ethPriceStats.h24Change < 0 ? "text-red-400" : "text-green-400";
    const gweiColor = (0,fp/* pipe */.zG)(baseFeePerGas, fp.O.map((baseFeePerGas)=>baseFeePerGas.wei > barrier ? "text-orange-400" : "text-blue-400"), fp.O.getOrElse(()=>""));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceGasBoundary, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "\n          flex items-center\n          rounded bg-slateus-700\n          px-3 py-2\n          text-xs\n          font-normal\n          lg:text-sm\n        ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex select-none items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: gas_slateus,
                        alt: "gas pump icon",
                        width: "14",
                        height: "14",
                        priority: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                    font: "font-roboto",
                    weight: "font-normal",
                    className: "pl-1",
                    children: [
                        (0,fp/* pipe */.zG)(baseFeePerGas, fp.O.match(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                width: "0.5rem"
                            }), (baseFeePerGas)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                className: gweiColor,
                                decimals: 1,
                                duration: 0.8,
                                end: format/* gweiFromWei */.Zb(baseFeePerGas.wei),
                                preserveValue: true,
                                separator: ",",
                                start: format/* gweiFromWei */.Zb(baseFeePerGas.wei)
                            }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                            font: "font-roboto",
                            color: "text-slateus-400",
                            weight: "font-normal",
                            children: "Gwei"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mr-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex select-none items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "select-none",
                        src: eth_slateus,
                        alt: "Ethereum Ether icon",
                        width: "14",
                        height: "14",
                        priority: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                    font: "font-roboto",
                    className: "pl-1",
                    weight: "font-normal",
                    children: [
                        ethPriceStats === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "2.65rem"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                            decimals: 0,
                            duration: 0.8,
                            end: ethPriceStats.usd,
                            preserveValue: true,
                            separator: ",",
                            start: ethPriceStats.usd
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                            font: "font-roboto",
                            color: "text-slateus-400",
                            weight: "font-normal",
                            children: "USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                            font: "font-roboto",
                            weight: "font-normal",
                            className: "".concat(color),
                            children: [
                                "(",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                    width: "2.5rem",
                                    children: ethUsd24hChange
                                }),
                                ")"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TopBar_PriceGasWidget = (PriceGasWidget);

;// CONCATENATED MODULE: ./src/mainsite/components/TopBar/index.tsx










const TopBar = ()=>{
    const [gasAlarmActive, setGasAlarmActive] = useLocalStorage("gas-alarm-enabled", false);
    const [ethAlarmActive, setEthAlarmActive] = useLocalStorage("eth-alarm-enabled", false);
    const [showAlarmDialog, setShowAlarmDialog] = (0,react.useState)(false);
    const notification = use_notification();
    const dialogRef = (0,react.useRef)(null);
    const alarmButtonRef = (0,react.useRef)(null);
    // Always start false, to avoid SSR mismatch.
    const [isAlarmActive, setIsAlarmActive] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsAlarmActive(gasAlarmActive || ethAlarmActive);
    }, [
        ethAlarmActive,
        gasAlarmActive
    ]);
    const checkIfClickedOutside = (0,react.useCallback)((e)=>{
        if (!showAlarmDialog || e.target === null || dialogRef.current !== null && dialogRef.current.contains(e.target) || alarmButtonRef.current !== null && alarmButtonRef.current.contains(e.target)) {
            return;
        }
        setShowAlarmDialog(false);
    }, [
        showAlarmDialog
    ]);
    const handleClickAlarm = (0,react.useCallback)(()=>{
        setShowAlarmDialog(!showAlarmDialog);
    }, [
        showAlarmDialog
    ]);
    const showAlarmDialogCss = showAlarmDialog ? "visible" : "invisible";
    (0,react.useEffect)(()=>{
        document.addEventListener("click", checkIfClickedOutside);
        return ()=>{
            document.removeEventListener("click", checkIfClickedOutside);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between pt-4 md:pt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_PriceGasWidget, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        ref: alarmButtonRef,
                        className: "\n            ml-4 flex\n            select-none items-center rounded\n            bg-slateus-700\n            px-3 py-2\n            ".concat(notification.type === "Supported" ? "visible" : "invisible", "\n            ").concat(isAlarmActive ? "bg-slateus-600" : "", "\n          "),
                        onClick: handleClickAlarm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: bell_slateus,
                            alt: "bell icon",
                            width: "14",
                            height: "14",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: dialogRef,
                        className: "absolute top-12 w-full rounded bg-slateus-700 p-8 md:top-12 ".concat(showAlarmDialogCss),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                children: "price alerts"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_AlarmInput, {
                                isAlarmActive: gasAlarmActive,
                                onToggleIsAlarmActive: setGasAlarmActive,
                                unit: "Gwei",
                                type: "gas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_AlarmInput, {
                                isAlarmActive: ethAlarmActive,
                                onToggleIsAlarmActive: setEthAlarmActive,
                                unit: "USD ",
                                type: "eth"
                            }),
                            notification.type === "Supported" && notification.permission === "denied" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-sm text-red-400",
                                children: "notifications disabled, please grant notification permission."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-x-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "hidden select-none font-medium hover:brightness-90 active:brightness-75 md:block",
                    href: "#fam",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "rounded-3xl border-2 border-solid border-white px-4 py-1 text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                            color: "",
                            font: "font-inter",
                            weight: "font-medium",
                            children: "join the fam"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_TopBar = (TopBar);

// EXTERNAL MODULE: ./src/mainsite/hardforks/paris.ts
var paris = __webpack_require__(62105);
;// CONCATENATED MODULE: ./src/mainsite/hooks/use-auth-from-section.ts

const useAuthFromSection = ()=>useLocalStorage("auth-from-section", "empty");
/* harmony default export */ var use_auth_from_section = (useAuthFromSection);

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(33040);
// EXTERNAL MODULE: ./src/components/TextsNext/QuantifyText.tsx
var QuantifyText = __webpack_require__(90079);
// EXTERNAL MODULE: ./src/components/Twemoji.tsx
var Twemoji = __webpack_require__(63365);
// EXTERNAL MODULE: ./src/components/WidgetErrorBoundary.tsx + 1 modules
var WidgetErrorBoundary = __webpack_require__(46400);
// EXTERNAL MODULE: ./src/mainsite/components/TimeFrameIndicator.tsx
var TimeFrameIndicator = __webpack_require__(62925);
;// CONCATENATED MODULE: ./src/relay/components/WidgetBase.tsx




const WidgetBase = (param)=>/*#__PURE__*/ {
    let { children , className ="" , hideTimeFrameLabel , onClickTimeFrame , timeFrame , title  } = param;
    return (0,jsx_runtime.jsx)(WidgetErrorBoundary/* default */.Z, {
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
            className: "flex flex-col gap-y-4 ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center gap-2-x",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: title
                        }),
                        timeFrame && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameIndicator/* default */.Z, {
                            hideTimeFrameLabel: hideTimeFrameLabel,
                            onClickTimeFrame: onClickTimeFrame,
                            timeFrame: timeFrame
                        })
                    ]
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var components_WidgetBase = (WidgetBase);

// EXTERNAL MODULE: ./src/components/BlueButton.tsx + 1 modules
var BlueButton = __webpack_require__(3680);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
;// CONCATENATED MODULE: ./src/mainsite/api/profiles.ts


const useProfiles = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/fam/profiles", fetchers/* fetchJsonSwr */.Ar);
    return data;
};
const useAllProfiles = ()=>{
    const { data  } = useSWR("/api/fam/all-profiles", fetchJsonSwr);
    return data;
};
const useSpriteSheet = ()=>{
    const { data  } = useSWR("/api/fam/sprite-sheet-meta", fetchJsonSwr);
    return data;
};

// EXTERNAL MODULE: ./src/mainsite/utils/use-active-breakpoint.ts
var use_active_breakpoint = __webpack_require__(95251);
// EXTERNAL MODULE: ./src/mainsite/components/ImageWithTooltip.tsx + 1 modules
var ImageWithTooltip = __webpack_require__(13852);
// EXTERNAL MODULE: ./src/mainsite/components/Modal.tsx
var Modal = __webpack_require__(33181);
// EXTERNAL MODULE: ./src/mainsite/components/FamTooltip.tsx + 1 modules
var FamTooltip = __webpack_require__(93964);
;// CONCATENATED MODULE: ./src/mainsite/components/FamExplorerV1.tsx








// See if merging with leaderboards tooltip makes sense after making it more generic.
const useTooltip = ()=>{
    const { md  } = (0,use_active_breakpoint/* useActiveBreakpoint */.P)();
    const [refEl, setRefEl] = (0,react.useState)(null);
    const [popperEl, setPopperEl] = (0,react.useState)(null);
    const { styles , attributes  } = (0,usePopper/* usePopper */.D)(refEl, popperEl, {
        placement: "right",
        modifiers: [
            {
                name: "flip"
            }
        ]
    });
    const [selectedItem, setSelectedItem] = (0,react.useState)();
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const onTooltip = (0,react.useRef)(false);
    const onImage = (0,react.useRef)(false);
    const handleImageMouseEnter = (0,react.useCallback)((profile, ref)=>{
        // The ranking data isn't there yet so no tooltip can be shown.
        if (profile === undefined) {
            return;
        }
        onImage.current = true;
        // Delayed show.
        const id = window.setTimeout(()=>{
            if (onImage.current || onTooltip.current) {
                setRefEl(ref.current);
                setSelectedItem(profile);
                setShowTooltip(true);
            }
        }, 300);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleImageMouseLeave = (0,react.useCallback)(()=>{
        onImage.current = false;
        // Delayed hide.
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedItem(undefined);
            }
        }, 300);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleTooltipEnter = (0,react.useCallback)(()=>{
        onTooltip.current = true;
    }, []);
    const handleTooltipLeave = (0,react.useCallback)(()=>{
        onTooltip.current = false;
        // Delayed hide.
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedItem(undefined);
            }
        }, 100);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleClickImage = (0,react.useCallback)((ranking)=>{
        if (md) {
            return;
        }
        setSelectedItem(ranking);
    }, [
        md,
        setSelectedItem
    ]);
    return {
        attributes,
        handleClickImage,
        handleImageMouseEnter,
        handleImageMouseLeave,
        handleTooltipEnter,
        handleTooltipLeave,
        selectedItem,
        setPopperEl,
        setSelectedItem,
        showTooltip,
        popperStyles: styles
    };
};
const FamExplorerV1 = ()=>{
    var ref;
    const profiles = (ref = useProfiles()) === null || ref === void 0 ? void 0 : ref.profiles;
    const { md  } = (0,use_active_breakpoint/* useActiveBreakpoint */.P)();
    // Support profile skeletons.
    const currentProfiles = profiles === undefined ? new Array(120).fill(undefined) : profiles;
    const { attributes , handleClickImage , handleImageMouseEnter , handleImageMouseLeave , handleTooltipEnter , handleTooltipLeave , popperStyles , selectedItem , setPopperEl , setSelectedItem , showTooltip  } = useTooltip();
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap justify-center",
                children: currentProfiles.map((profile, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageWithTooltip/* default */.Z, {
                        className: "m-2 w-10 h-10 select-none",
                        imageUrl: profile === null || profile === void 0 ? void 0 : profile.profileImageUrl,
                        isDoneLoading: profile !== undefined,
                        skeletonDiameter: "40px",
                        onMouseEnter: (ref)=>!md || profile === undefined ? ()=>undefined : handleImageMouseEnter(profile, ref),
                        onMouseLeave: ()=>!md ? ()=>undefined : handleImageMouseLeave(),
                        onClick: ()=>handleClickImage(profile),
                        height: 40,
                        width: 40
                    }, (ref1 = profile === null || profile === void 0 ? void 0 : profile.profileUrl) !== null && ref1 !== void 0 ? ref1 : index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: setPopperEl,
                        className: "hidden z-10 p-4 md:block",
                        style: {
                            ...popperStyles.popper,
                            visibility: showTooltip && md ? "visible" : "hidden"
                        },
                        ...attributes.popper,
                        onMouseEnter: handleTooltipEnter,
                        onMouseLeave: handleTooltipLeave,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            description: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.bio,
                            famFollowerCount: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.famFollowerCount,
                            followerCount: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.followersCount,
                            imageUrl: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.profileImageUrl,
                            links: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.links,
                            title: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name,
                            twitterUrl: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.profileUrl,
                            width: "min-w-[20rem] max-w-sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onClickBackground: ()=>setSelectedItem(undefined),
                        show: !md && selectedItem !== undefined,
                        children: !md && selectedItem !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            description: selectedItem.bio,
                            famFollowerCount: selectedItem.famFollowerCount,
                            followerCount: selectedItem.followersCount,
                            imageUrl: selectedItem.profileImageUrl,
                            links: selectedItem.links,
                            onClickClose: ()=>setSelectedItem(undefined),
                            title: selectedItem.name,
                            twitterUrl: selectedItem.profileUrl,
                            width: "min-w-[18rem] max-w-md"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FamExplorerV1 = (FamExplorerV1);

;// CONCATENATED MODULE: ./src/mainsite/sections/FamSection.tsx









const FamSection = ()=>{
    // const profiles = useAllProfiles()?.profiles;
    const [isCopiedFeedbackVisible, setIsCopiedFeedbackVisible] = (0,react.useState)(false);
    // Copy batsound feedback
    const onBatSoundCopied = ()=>{
        setIsCopiedFeedbackVisible(true);
        setTimeout(()=>setIsCopiedFeedbackVisible(false), 800);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        title: "join the fam",
        link: "fam",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-x-4 gap-y-4 w-full lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WidgetBase, {
                        className: "w-full",
                        title: "fam count",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                            size: "text-3xl ",
                            unitPostfix: "members",
                            unitPostfixMargin: "ml-2",
                            children: "6,000+"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WidgetBase, {
                        className: "w-full",
                        title: "wear the bat signal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Twemoji/* default */.Z, {
                                    className: "flex gap-x-1",
                                    imageClassName: "w-11",
                                    wrapper: true,
                                    children: "\uD83E\uDD87\uD83D\uDD0A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                    text: "\uD83E\uDD87\uD83D\uDD0A",
                                    onCopy: onBatSoundCopied,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueButton/* default */.Z, {
                                            children: isCopiedFeedbackVisible ? "copied!" : "copy"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FamExplorerV1, {})
        ]
    }, "fam");
};
/* harmony default export */ var sections_FamSection = (FamSection);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/lodash/maxBy.js
var maxBy = __webpack_require__(84753);
var maxBy_default = /*#__PURE__*/__webpack_require__.n(maxBy);
// EXTERNAL MODULE: ./src/mainsite/api/base-fee-over-time.ts
var base_fee_over_time = __webpack_require__(40662);
;// CONCATENATED MODULE: ./src/mainsite/sections/GasSection.tsx








const BaseFeesWidget = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(111), __webpack_require__.e(344), __webpack_require__.e(591)]).then(__webpack_require__.bind(__webpack_require__, 72591)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72591)
            ]
    },
    ssr: false
});
const GasMarketWidget = dynamic_default()(()=>__webpack_require__.e(/* import() */ 674).then(__webpack_require__.bind(__webpack_require__, 45674)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45674)
            ]
    },
    ssr: false
});
const GasStreakWidget = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(585), __webpack_require__.e(902)]).then(__webpack_require__.bind(__webpack_require__, 88902)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(88902)
            ]
    },
    ssr: false
});
const pointsFromBaseFeesOverTime = (baseFeesD1)=>baseFeesD1.map((param)=>{
        let { wei , timestamp  } = param;
        return [
            (0,parseISO/* default */.Z)(timestamp).getTime(),
            wei / eth_units/* WEI_PER_GWEI */.c1
        ];
    });
const GasSection = (param)=>{
    let { timeFrame , onClickTimeFrame  } = param;
    const baseFeesOverTime = (0,base_fee_over_time/* useBaseFeeOverTime */.Y)();
    const [baseFeesSeries, max] = (0,react.useMemo)(()=>{
        if (baseFeesOverTime === undefined) {
            return [
                undefined,
                undefined
            ];
        }
        var _timeFrame;
        const baseFeesOverTimeTimeFrame = (_timeFrame = baseFeesOverTime[timeFrame]) !== null && _timeFrame !== void 0 ? _timeFrame : undefined;
        const series = baseFeesOverTimeTimeFrame === undefined ? undefined : pointsFromBaseFeesOverTime(baseFeesOverTimeTimeFrame);
        const max = maxBy_default()(series, (point)=>point[1]);
        return [
            series,
            max
        ];
    }, [
        baseFeesOverTime,
        timeFrame
    ]);
    const baseFeesMap = baseFeesSeries === undefined ? undefined : Object.fromEntries(new Map(baseFeesSeries).entries());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        link: "gas",
        subtitle: "gas is the new oil",
        title: "gas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-y-4 gap-x-4 lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full lg:w-1/2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseFeesWidget, {
                        barrier: baseFeesOverTime === null || baseFeesOverTime === void 0 ? void 0 : baseFeesOverTime.barrier,
                        baseFeesSeries: baseFeesSeries,
                        baseFeesMap: baseFeesMap !== null && baseFeesMap !== void 0 ? baseFeesMap : {},
                        max: max === null || max === void 0 ? void 0 : max[1],
                        timeFrame: timeFrame,
                        onClickTimeFrame: onClickTimeFrame
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col gap-y-4 lg:w-1/2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GasMarketWidget, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: onClickTimeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GasStreakWidget, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_GasSection = (GasSection);

// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
;// CONCATENATED MODULE: ./src/mainsite/api/flippening-data.ts



const useFlippeningData = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/v2/fees/flippening-data", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromMinutes */.wb(60)
    });
    return data;
};

// EXTERNAL MODULE: ./src/mainsite/api/market-caps.ts
var market_caps = __webpack_require__(16382);
;// CONCATENATED MODULE: ./src/mainsite/sections/FlippeningSection.tsx







const MarketCapRatioWidget = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(111), __webpack_require__.e(183)]).then(__webpack_require__.bind(__webpack_require__, 30183)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(30183)
            ]
    },
    ssr: false
});
function generateExponentialGrowthData(startTimestamp, startValue, endTimestamp, endValue) {
    let targetValue = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1.0;
    // Calculate the number of days between the start and end dates
    const daysBetween = (endTimestamp - startTimestamp) / (1000 * 3600 * 24);
    // Calculate the growth rate r
    const r = Math.log(endValue / startValue) / daysBetween;
    // Initialize the array to store the daily values
    const data = [];
    // Generate the daily values until the target value is reached
    let currentTimestamp = startTimestamp;
    let currentValue = startValue;
    while(currentValue < targetValue){
        data.push([
            currentTimestamp,
            currentValue * 100
        ]);
        currentTimestamp += 1000 * 3600 * 24; // Increment the timestamp by one day in milliseconds
        currentValue = startValue * Math.exp(r * ((currentTimestamp - startTimestamp) / (1000 * 3600 * 24)));
    }
    // Ensure the target value is included as the last point
    data.push([
        currentTimestamp,
        currentValue * 100
    ]);
    return data;
}
const pointsFromMarketCapRatiosOverTime = (marketCapRatios, currentRatio)=>{
    var ref;
    const ratioSeries = marketCapRatios.map((param)=>{
        let { marketcapRatio , t  } = param;
        return [
            t * 1000,
            marketcapRatio * 100
        ];
    });
    const now = new Date();
    const utcYear = now.getUTCFullYear();
    const utcMonth = now.getUTCMonth();
    const utcDate = now.getUTCDate();
    const todayUTC = Date.UTC(utcYear, utcMonth, utcDate);
    const lastDatapoint = ratioSeries === null || ratioSeries === void 0 ? void 0 : (ref = ratioSeries[ratioSeries.length - 1]) === null || ref === void 0 ? void 0 : ref[0];
    if (lastDatapoint !== undefined && lastDatapoint >= todayUTC) {
        ratioSeries.pop();
    }
    if (currentRatio !== undefined) {
        ratioSeries.push([
            todayUTC,
            currentRatio * 100
        ]);
    }
    return ratioSeries;
};
const FlippeningSection = ()=>{
    const flippeningData = useFlippeningData();
    const marketCaps = (0,market_caps/* useMarketCaps */.i)();
    const [marketCapRatiosSeries, exponentialGrowthCurveSeries, maxMarketCap, maxExponentialGrowthCurve] = (0,react.useMemo)(()=>{
        if (flippeningData === undefined) {
            return [
                undefined,
                undefined
            ];
        }
        const currentRatio = marketCaps === undefined ? undefined : marketCaps.ethMarketCap / marketCaps.btcMarketCap;
        const series = pointsFromMarketCapRatiosOverTime(flippeningData, currentRatio);
        const maxMarketCap = maxBy_default()(series, (point)=>point[1]);
        let expontentialGrowthCurve = [];
        if (series !== undefined && series.length > 1) {
            const startingPoint = series[0];
            const endPoint = series[series.length - 1];
            if (startingPoint !== undefined && endPoint !== undefined) {
                expontentialGrowthCurve = generateExponentialGrowthData(startingPoint[0], startingPoint[1] / 100, endPoint[0], endPoint[1] / 100);
            }
        }
        const maxExponentialCurve = maxBy_default()(expontentialGrowthCurve, (point)=>point[1]);
        return [
            series,
            expontentialGrowthCurve,
            maxMarketCap,
            maxExponentialCurve
        ];
    }, [
        flippeningData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        link: "flippening",
        subtitle: "it's happening™",
        title: "flippening",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full flex-col gap-y-4 gap-x-4 lg:flex-row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketCapRatioWidget, {
                    marketCapRatiosSeries: marketCapRatiosSeries,
                    maxMarketCap: maxMarketCap === null || maxMarketCap === void 0 ? void 0 : maxMarketCap[1],
                    exponentialGrowthCurveSeries: exponentialGrowthCurveSeries,
                    maxExponentialGrowthCurve: maxMarketCap === null || maxMarketCap === void 0 ? void 0 : maxMarketCap[1]
                })
            })
        })
    });
};
/* harmony default export */ var sections_FlippeningSection = (FlippeningSection);

;// CONCATENATED MODULE: ./src/mainsite/sections/BlobGasSection.tsx







const BlobFeesWidget = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(111), __webpack_require__.e(344), __webpack_require__.e(780)]).then(__webpack_require__.bind(__webpack_require__, 74780)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(74780)
            ]
    },
    ssr: false
});
const BlobGasMarketWidget = dynamic_default()(()=>__webpack_require__.e(/* import() */ 981).then(__webpack_require__.bind(__webpack_require__, 57981)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57981)
            ]
    },
    ssr: false
});
const BlobBurnWidget = dynamic_default()(()=>__webpack_require__.e(/* import() */ 343).then(__webpack_require__.bind(__webpack_require__, 37343)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37343)
            ]
    },
    ssr: false
});
const BlobGasSection_pointsFromBaseFeesOverTime = (baseFeesD1)=>baseFeesD1.map((param)=>{
        let { blob_wei , timestamp  } = param;
        return [
            (0,parseISO/* default */.Z)(timestamp).getTime(),
            blob_wei !== null && blob_wei !== void 0 ? blob_wei : 0
        ];
    });
const BlobGasSection = (param)=>{
    let { timeFrame , onClickTimeFrame  } = param;
    const baseFeesOverTime = (0,base_fee_over_time/* useBaseFeeOverTime */.Y)();
    const [baseFeesSeries, max] = (0,react.useMemo)(()=>{
        if (baseFeesOverTime === undefined) {
            return [
                undefined,
                undefined
            ];
        }
        var _timeFrame;
        const baseFeesOverTimeTimeFrame = (_timeFrame = baseFeesOverTime[timeFrame]) !== null && _timeFrame !== void 0 ? _timeFrame : undefined;
        const series = baseFeesOverTimeTimeFrame === undefined ? undefined : BlobGasSection_pointsFromBaseFeesOverTime(baseFeesOverTimeTimeFrame);
        const max = maxBy_default()(series, (point)=>point[1]);
        return [
            series,
            max
        ];
    }, [
        baseFeesOverTime,
        timeFrame
    ]);
    const baseFeesMap = baseFeesSeries === undefined ? undefined : Object.fromEntries(new Map(baseFeesSeries).entries());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        link: "blobs",
        subtitle: "the blobs are here",
        title: "blob gas",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-y-4 gap-x-4 lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full lg:w-1/2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlobFeesWidget, {
                        baseFeesSeries: baseFeesSeries,
                        baseFeesMap: baseFeesMap !== null && baseFeesMap !== void 0 ? baseFeesMap : {},
                        max: max === null || max === void 0 ? void 0 : max[1],
                        timeFrame: timeFrame,
                        onClickTimeFrame: onClickTimeFrame
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full flex-col gap-y-4 lg:w-1/2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlobGasMarketWidget, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: onClickTimeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlobBurnWidget, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: onClickTimeFrame
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_BlobGasSection = (BlobGasSection);

// EXTERNAL MODULE: ./src/time.ts
var time = __webpack_require__(34614);
// EXTERNAL MODULE: ./src/mainsite/components/HoverTooltip.tsx
var HoverTooltip = __webpack_require__(56862);
;// CONCATENATED MODULE: ./src/assets/nerd-slateus.svg
/* harmony default export */ var nerd_slateus = ({"src":"/_next/static/media/nerd-slateus.042be4dd.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/nerd-own.svg
/* harmony default export */ var nerd_own = ({"src":"/_next/static/media/nerd-own.bccb0948.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/mainsite/components/Nerd.tsx




const Nerd = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        gray-nerd\n        relative\n        z-10\n        ml-2 flex cursor-pointer select-none\n        hover:opacity-0 [&+.color-nerd]:active:brightness-75\n      ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "a nerd emoji offering deeper explanation of a nearby metric",
                    height: 21,
                    priority: true,
                    src: nerd_slateus,
                    width: 21
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 ml-2 select-none color-nerd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "a colored nerd emoji offering deeper explanation of a nearby metric",
                    height: 21,
                    src: nerd_own,
                    width: 21
                })
            })
        ]
    });
};
/* harmony default export */ var components_Nerd = (Nerd);

// EXTERNAL MODULE: ./src/mainsite/components/UpdatedAgo.tsx
var UpdatedAgo = __webpack_require__(2477);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var next_image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/assets/round-nerd-large.svg
var round_nerd_large = __webpack_require__(92537);
// EXTERNAL MODULE: ./src/components/TextsNext/LabelText.tsx
var LabelText = __webpack_require__(89802);
// EXTERNAL MODULE: ./node_modules/lodash/dropRight.js
var dropRight = __webpack_require__(43624);
var dropRight_default = /*#__PURE__*/__webpack_require__.n(dropRight);
// EXTERNAL MODULE: ./node_modules/lodash/flow.js
var flow = __webpack_require__(59242);
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);
// EXTERNAL MODULE: ./node_modules/lodash/takeRight.js
var takeRight = __webpack_require__(69579);
var takeRight_default = /*#__PURE__*/__webpack_require__.n(takeRight);
// EXTERNAL MODULE: ./src/mainsite/components/Amount.tsx
var Amount = __webpack_require__(30772);
;// CONCATENATED MODULE: ./src/mainsite/components/CurrentSupplyWidget/PreciseEth.tsx










// For a wei number 119,144,277,858,326,743,920,488,300 we want to display the
// full number, and animate it. For display we could use strings, but for
// animation we need numbers. Numbers are sufficiently large where we run
// against low level limits (IEEE 754), and can't work with the full number. We
// split the number into three parts, to enable both precision and animation.
const ethNoDecimals = flow_default()((ethSupplySum)=>ethSupplySum.toString().split(""), (chars)=>dropRight_default()(chars, 18), (str)=>str.join(""), (str)=>jsbi_umd_default().BigInt(str), (num)=>jsbi_umd_default().toNumber(num));
// The last six digits in the number.
const ethLastSixteenDecimals = flow_default()((ethSupplySum)=>ethSupplySum.toString().split(""), (chars)=>takeRight_default()(chars, 16), (str)=>str.join(""), (str)=>jsbi_umd_default().BigInt(str), (num)=>jsbi_umd_default().toNumber(num));
// Everything that is left from the fractional part when written in ETH instead of Wei. This is always twelve digits.
const ethFirstTwoDecimals = flow_default()((ethSupplySum)=>ethSupplySum.toString().split(""), (chars)=>dropRight_default()(chars, 16), (chars)=>takeRight_default()(chars, 2), (str)=>str.join(""), (str)=>jsbi_umd_default().BigInt(str), (num)=>jsbi_umd_default().toNumber(num));
const formatDecimals = (num, padTo)=>{
    const numsAsStrings = num.toString().padStart(padTo, "0").split("").reverse();
    const result = [];
    for(let i = 0; i < numsAsStrings.length; i++){
        if (i !== 0 && i % 3 === 0) {
            result.push(",");
        }
        result.push(numsAsStrings[i]);
    }
    return result.reverse().join("");
};
const Digits = (param)=>{
    let { children  } = param;
    const padTwoDecimals = (0,react.useCallback)((num)=>formatDecimals(num, 2), []);
    const padSixteenDecimals = (0,react.useCallback)((num)=>formatDecimals(num, 16), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative -mr-1 w-[30px] md:mt-[1px] md:w-[38px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // We need whitespace-normal to counteract the whitespace-nowrap from our parent.
                className: "\n          absolute block\n          h-2 w-3\n          overflow-hidden\n          whitespace-normal break-all\n          text-[7px]\n          leading-[6px]\n          text-white\n          md:text-[9px]\n          md:leading-[8px]\n        ",
                children: ethFirstTwoDecimals(children) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "00"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                    duration: 0.5,
                    end: ethFirstTwoDecimals(children),
                    formattingFn: padTwoDecimals,
                    preserveValue: true,
                    separator: ",",
                    start: ethFirstTwoDecimals(children),
                    useEasing: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                // We need whitespace-normal to counteract the whitespace-nowrap from our parent.
                className: "\n          left-0 block\n          whitespace-normal break-all\n          text-[7px]\n          leading-[6px] text-slateus-200\n          md:text-[9px]\n          md:leading-[8px]\n        ",
                children: [
                    "\xa0\xa0",
                    ethLastSixteenDecimals(children) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "0,000,000,000,000,000"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                        end: ethLastSixteenDecimals(children),
                        formattingFn: padSixteenDecimals,
                        preserveValue: true,
                        separator: ",",
                        start: ethLastSixteenDecimals(children),
                        useEasing: false
                    })
                ]
            })
        ]
    });
};
const PreciseEth = (param)=>{
    let { amount , justify  } = param;
    const [blinkOrange, setBlinkOrange] = (0,react.useState)(false);
    const [blinkBlue, setBlinkBlue] = (0,react.useState)(false);
    const lastAmount = (0,react.useRef)(amount);
    const handleBlinkOrange = (0,react.useCallback)(()=>{
        setBlinkOrange(true);
        const id = setTimeout(()=>{
            setBlinkOrange(false);
        }, 1000);
        return ()=>window.clearTimeout(id);
    }, []);
    const handleBlinkBlue = (0,react.useCallback)(()=>{
        setBlinkBlue(true);
        const id = setTimeout(()=>{
            setBlinkBlue(false);
        }, 1000);
        return ()=>window.clearTimeout(id);
    }, []);
    (0,react.useEffect)(()=>{
        if (jsbi_umd_default().equal(lastAmount.current, amount)) {
            return;
        }
        const isPositiveDelta = jsbi_umd_default().greaterThan(jsbi_umd_default().subtract(amount, lastAmount.current), jsbi_umd_default().BigInt(0));
        if (isPositiveDelta) {
            handleBlinkBlue();
        } else {
            handleBlinkOrange();
        }
        lastAmount.current = amount;
    }, [
        amount,
        handleBlinkBlue,
        handleBlinkOrange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
        className: "\n      flex items-center tracking-tight\n      ".concat(justify !== undefined ? justify : "", "\n      ").concat(blinkBlue ? "animate-flash-blue" : "", "\n      ").concat(blinkOrange ? "animate-flash-orange" : "", "\n    "),
        size: "text-2xl md:text-3xl",
        unitPostfix: "ETH",
        unitPostfixMargin: "ml-2",
        unitPostfixColor: "text-slateus-200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                    decimals: 0,
                    duration: Amount/* defaultMoneyAnimationDuration */.fT,
                    end: ethNoDecimals(amount),
                    preserveValue: true,
                    separator: ",",
                    start: ethNoDecimals(lastAmount.current)
                }),
                ".",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Digits, {
                    children: amount
                })
            ]
        })
    });
};
/* harmony default export */ var CurrentSupplyWidget_PreciseEth = (PreciseEth);

;// CONCATENATED MODULE: ./src/mainsite/components/CurrentSupplyWidget/CurrentSupplyTooltip.tsx






const FormulaText = (param)=>/*#__PURE__*/ {
    let { className , inline , children  } = param;
    return (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
        font: "font-inter",
        className: className,
        size: "text-base md:text-lg",
        inline: inline,
        children: children
    });
};
const CurrentSupplyTooltip = (param)=>/*#__PURE__*/ {
    let { ethSupply , onClickClose  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "\n      relative\n      flex w-[22rem] flex-col gap-y-4\n      rounded-lg border border-slateus-400\n      bg-slateus-700 p-8\n      md:w-[23rem]\n    ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "a close button, circular with an x in the middle",
                className: "absolute top-5 right-5 w-6 cursor-pointer select-none hover:brightness-90 active:brightness-110",
                onClick: onClickClose,
                src: "/close.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                alt: "",
                className: "mx-auto w-20 h-20 rounded-full select-none",
                src: round_nerd_large/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* TooltipTitle */.CK, {
                children: "ETH supply breakdown"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                children: "formula"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormulaText, {
                        children: "supply = EVM balances +"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-[69px] md:ml-[77px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormulaText, {
                                inline: false,
                                children: "beacon chain balances -"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormulaText, {
                                children: "beacon chain deposits"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                children: "EVM balances"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget_PreciseEth, {
                amount: ethSupply.executionBalancesSum,
                justify: "justify-end"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                children: "beacon chain balances"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget_PreciseEth, {
                amount: ethSupply.beaconBalancesSum,
                justify: "justify-end"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                children: "beacon chain deposits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget_PreciseEth, {
                amount: ethSupply.beaconDepositsSum,
                justify: "justify-end"
            })
        ]
    });
};
/* harmony default export */ var CurrentSupplyWidget_CurrentSupplyTooltip = (CurrentSupplyTooltip);

;// CONCATENATED MODULE: ./src/mainsite/components/CurrentSupplyWidget/index.tsx











const EthSupplyWidget = ()=>{
    const ethSupplyParts = (0,supply_parts/* useSupplyParts */._D)();
    const ethSupply = (0,supply_parts/* ethSupplyFromParts */.us)(ethSupplyParts);
    const [showNerdTooltip, setShowNerdTooltip] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetErrorBoundary/* default */.Z, {
        title: "current supply",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex relative flex-col gap-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "\n                flex cursor-pointer\n                items-center\n                [&_.gray-nerd]:hover:opacity-0\n                [&_.color-nerd]:active:brightness-75\n            ",
                            onClick: ()=>setShowNerdTooltip(true),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "current supply"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverTooltip/* default */.Z, {
                                    customAlign: "-left-16",
                                    text: "Show how the current supply is calculated.",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Nerd, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "\n              tooltip\n              w-[calc(100% + 96px)] fixed top-1/2\n              left-1/2 z-30 -translate-x-1/2 -translate-y-1/2\n              cursor-auto\n              whitespace-nowrap\n              ".concat(showNerdTooltip ? "block" : "hidden", "\n            "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget_CurrentSupplyTooltip, {
                                ethSupply: ethSupplyParts,
                                onClickClose: ()=>setShowNerdTooltip(false)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-y-4 transition-colors",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget_PreciseEth, {
                                    amount: ethSupply
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatedAgo/* default */.Z, {
                                    updatedAt: (0,time/* dateTimeFromSlot */.Qr)(ethSupplyParts.slot).toISOString()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "\n            fixed top-0 left-0 bottom-0 right-0\n            z-20 flex items-center\n            justify-center\n            bg-slateus-700/60\n            backdrop-blur-sm\n            ".concat(showNerdTooltip ? "" : "hidden", "\n          "),
                    onClick: ()=>setShowNerdTooltip(false)
                })
            ]
        })
    });
};
/* harmony default export */ var CurrentSupplyWidget = (EthSupplyWidget);

// EXTERNAL MODULE: ./src/mainsite/components/CurrencyControl.tsx
var CurrencyControl = __webpack_require__(51508);
// EXTERNAL MODULE: ./src/mainsite/api/gauge-rates.ts
var gauge_rates = __webpack_require__(28835);
// EXTERNAL MODULE: ./node_modules/lodash/clamp.js
var clamp = __webpack_require__(74691);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
// EXTERNAL MODULE: ./node_modules/@react-spring/web/dist/react-spring-web.esm.js
var react_spring_web_esm = __webpack_require__(81472);
;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/droplet.svg
/* harmony default export */ var droplet = ({"src":"/_next/static/media/droplet.7fd48ac9.svg","height":27,"width":27});
;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/flame.svg
/* harmony default export */ var flame = ({"src":"/_next/static/media/flame.265ed060.svg","height":27,"width":27});
// EXTERNAL MODULE: ./node_modules/d3-shape/src/arc.js + 3 modules
var arc = __webpack_require__(80965);
;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/GaugeSvg.tsx




const getFillColor = (progressFillColor, gradientFillColor)=>progressFillColor !== undefined ? progressFillColor : gradientFillColor !== undefined ? "url(#".concat(gradientFillColor, "-gradient-base-gauge)") : colors/* default.slateus200 */.Z.slateus200;
const tau = 2 * Math.PI;
const thickness = 11;
const innerRadius = 80;
const width = 2 * (innerRadius + thickness);
const height = 2 * (innerRadius + thickness);
// Portion of a full circle which is filled by the gauge.
const arcFraction = 2 / 3;
const arcStartAngle = -tau / 3;
const arcGen = arc/* default */.Z().cornerRadius(thickness);
// Config to render the arc with the endAngle still missing.
const arcBase = {
    innerRadius: innerRadius,
    outerRadius: innerRadius + thickness,
    startAngle: arcStartAngle
};
// Inputs are static, no reason to fear output would suddenly be null.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const backgroundArc = arcGen({
    ...arcBase,
    endAngle: arcStartAngle + arcFraction * tau
});
var ref;
const arcPathFromProgress = (progress)=>(ref = arcGen({
        ...arcBase,
        endAngle: arcStartAngle + arcFraction * tau * progress
    })) !== null && ref !== void 0 ? ref : "";
const GaugeSvg = (param)=>{
    let { progress =0 , matteFill: progressFillColor , gradientFill: gradientFillColor , needleColor ="white"  } = param;
    const { progressSpring  } = (0,react_spring_web_esm.useSpring)({
        from: {
            progressSpring: 0
        },
        to: {
            progressSpring: progress
        },
        delay: 200,
        config: react_spring_web_esm.config.gentle
    });
    const fillColor = getFillColor(progressFillColor, gradientFillColor);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        y1: "1",
                        id: "orange-gradient-base-gauge",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#E79800"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#EDDB36"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "blue-gradient-base-gauge",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#67e8f9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#6366f1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(".concat(width / 2, ",").concat(height / 2, ")"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        style: {
                            fill: colors/* default.slateus500 */.Z.slateus500
                        },
                        d: backgroundArc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        d: progressSpring.to(arcPathFromProgress),
                        fill: fillColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        transform: progressSpring.to((x)=>"rotate(".concat(-210 + x * arcFraction * 360, ")")),
                        style: {
                            fill: needleColor
                        },
                        d: "M 0 -4 L 64 0 L 64 0 L 0 4 A 1 1 0 0 1 0 -4"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Gauges_GaugeSvg = (GaugeSvg);

;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/IssuanceBurnBaseGauge.tsx












const formatValue = (unit, gaugeUnit, value)=>{
    const num = unit === "eth" ? format/* formatZeroDecimals */.UY(value) : format/* formatOneDecimal */.F9(value / 1000);
    return "".concat(num).concat(gaugeUnit);
};
const IssuanceBurnBaseGauge = (param)=>{
    let { emoji , gaugeUnit , gradientFill , needleColor , title , unit , value , valueUnit  } = param;
    // We scale the thousands of ETH down to hundreds, and the billions of USD to
    // thousands to make the animation distance small when toggling between them.
    // This prevents the number overshooting by the millions when it tries to
    // animate from some number of billions to some number of thousands. Because
    // USD is in billions and we divide by a million we get thousands, but we'd
    // like to display in single decimals billions. We therefore divide by a
    // thousand again, during formatting, after animation has happened.
    const valueScaled = value === undefined ? undefined : unit === "eth" ? value / 1000 : value / 1000000;
    const { valueSpring  } = (0,react_spring_web_esm.useSpring)({
        from: {
            valueSpring: 0
        },
        to: {
            valueSpring: valueScaled
        },
        delay: 200,
        config: react_spring_web_esm.config.gentle
    });
    const min = 0;
    const max = unit === "eth" ? 6000000 : 10000000000;
    const progress = clamp_default()(value !== null && value !== void 0 ? value : 0, min, max) / (max - min);
    const { previewSkeletons  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 scale-90 lg:scale-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_GaugeSvg, {
                        gradientFill: gradientFill,
                        needleColor: needleColor,
                        progress: progress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "\n            -mt-[60px] text-center font-roboto text-3xl\n            font-light\n          ",
                        children: value === undefined || previewSkeletons ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "-mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                    inline: true,
                                    width: "28px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: gaugeUnit
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.p, {
                            className: "\n              -mb-2 bg-gradient-to-r bg-clip-text\n              text-transparent\n              ".concat(title === "burn" ? "from-orange-400 to-yellow-300" : "from-cyan-300 to-indigo-500", "\n              "),
                            children: valueSpring.to(formatValue.bind(null, unit, gaugeUnit))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-[7px] mb-2.5 select-none font-roboto text-xs font-light text-slateus-200",
                children: valueUnit
            }),
            emoji === "flame" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "image of a flame signifying ETH burned",
                height: 24,
                src: flame,
                width: 24
            }) : emoji === "droplet" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "image of a droplet signifying ETH issued",
                height: 24,
                src: droplet,
                width: 24
            }) : null
        ]
    });
};
/* harmony default export */ var Gauges_IssuanceBurnBaseGauge = (IssuanceBurnBaseGauge);

;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/BurnGauge.tsx




const getRate = (gaugeRates, timeFrame, unit)=>gaugeRates === undefined ? undefined : gaugeRates[timeFrame].burn_rate_yearly[unit];
const BurnGauge = (param)=>{
    let { timeFrame , unit  } = param;
    const gaugeRates = (0,gauge_rates/* useGaugeRates */.f)();
    const selectedRate = getRate(gaugeRates, timeFrame, unit);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        flex flex-col items-center justify-start\n        rounded-lg\n        bg-slateus-700 px-4 pb-4 pt-7\n        md:rounded-none md:rounded-tl-lg md:px-0\n      ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_IssuanceBurnBaseGauge, {
            emoji: "flame",
            gaugeUnit: unit === "eth" ? "K" : "B",
            gradientFill: "orange",
            needleColor: colors/* default.orange400 */.Z.orange400,
            title: "burn",
            unit: unit,
            value: selectedRate,
            valueUnit: unit === "eth" ? "ETH/year" : "USD/year"
        })
    });
};
/* harmony default export */ var Gauges_BurnGauge = (BurnGauge);

;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/IssuanceGauge.tsx




const IssuanceGauge_getRate = (gaugeRates, simulateProofOfWork, timeFrame, unit)=>gaugeRates === undefined ? undefined : simulateProofOfWork ? gaugeRates[timeFrame].issuance_rate_yearly_pow[unit] : gaugeRates[timeFrame].issuance_rate_yearly[unit];
const IssuanceGauge = (param)=>{
    let { simulateProofOfWork: simulateProofOfWork , timeFrame , unit  } = param;
    const gaugeRates = (0,gauge_rates/* useGaugeRates */.f)();
    const issuance = IssuanceGauge_getRate(gaugeRates, simulateProofOfWork, timeFrame, unit);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        flex flex-col items-center justify-start\n        rounded-lg\n        bg-slateus-700 px-4 pb-4 pt-7\n        md:rounded-none md:rounded-tr-lg md:px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_IssuanceBurnBaseGauge, {
            emoji: "droplet",
            gaugeUnit: unit === "eth" ? "K" : "B",
            gradientFill: "blue",
            needleColor: colors/* default.blue400 */.Z.blue400,
            title: "issuance",
            unit: unit,
            value: issuance,
            valueUnit: unit === "eth" ? "ETH/year" : "USD/year"
        })
    });
};
/* harmony default export */ var Gauges_IssuanceGauge = (IssuanceGauge);

;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/SplitGaugeSvg.tsx
// Rendering the D3 arc paths on the server vs the safari client results in a different path. We ignore the hydration warning.




const SplitGaugeSvg_tau = 2 * Math.PI;
const SplitGaugeSvg_thickness = 11;
const SplitGaugeSvg_innerRadius = 80;
const SplitGaugeSvg_width = 2 * (SplitGaugeSvg_innerRadius + SplitGaugeSvg_thickness);
const SplitGaugeSvg_height = 2 * (SplitGaugeSvg_innerRadius + SplitGaugeSvg_thickness);
const backgroundArcFraction = 2 / 3;
const foregroundArcFraction = 3 / 3;
const backgroundStartAngle = -1 / 3 * SplitGaugeSvg_tau;
const SplitGaugeSvg_arcBase = {
    innerRadius: SplitGaugeSvg_innerRadius,
    outerRadius: SplitGaugeSvg_innerRadius + SplitGaugeSvg_thickness
};
const SplitGaugeSvg_arcGen = arc/* default */.Z().cornerRadius(SplitGaugeSvg_thickness);
var SplitGaugeSvg_ref;
const SplitGaugeSvg_backgroundArc = (SplitGaugeSvg_ref = SplitGaugeSvg_arcGen({
    ...SplitGaugeSvg_arcBase,
    startAngle: -SplitGaugeSvg_tau / 3,
    endAngle: backgroundStartAngle + backgroundArcFraction * SplitGaugeSvg_tau
})) !== null && SplitGaugeSvg_ref !== void 0 ? SplitGaugeSvg_ref : "";
var ref1;
const SplitGaugeSvg_arcPathFromProgress = (progress)=>(ref1 = SplitGaugeSvg_arcGen({
        ...SplitGaugeSvg_arcBase,
        startAngle: 0,
        endAngle: 1 / 3 * SplitGaugeSvg_tau * foregroundArcFraction * progress
    })) !== null && ref1 !== void 0 ? ref1 : "";
const needlePath = "M 0 -4 L 64 0 L 64 0 L 0 4 A 1 1 0 0 1 0 -4";
const rotationFromProgress = (progress)=>"rotate(".concat(-90 + progress * 120, ")");
const SplitGaugeSvg = (param)=>{
    let { progress =0  } = param;
    const { x  } = (0,react_spring_web_esm.useSpring)({
        from: {
            x: 0
        },
        to: {
            x: progress
        },
        delay: 200,
        config: react_spring_web_esm.config.gentle
    });
    const stylesBlue = (0,react_spring_web_esm.useSpring)({
        opacity: progress > 0 ? 1 : 0,
        delay: 200,
        config: react_spring_web_esm.config.gentle
    });
    const stylesOrange = (0,react_spring_web_esm.useSpring)({
        opacity: progress > 0 ? 0 : 1,
        delay: 200,
        config: react_spring_web_esm.config.gentle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: SplitGaugeSvg_width,
        height: SplitGaugeSvg_height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "orange-gradient-split-gauge",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#F4DD0C"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#F4900C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "blue-gradient-split-gauge",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#67e8f9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#6366f1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(".concat(SplitGaugeSvg_width / 2, ",").concat(SplitGaugeSvg_height / 2, ")"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        style: {
                            fill: colors/* default.slateus500 */.Z.slateus500
                        },
                        d: SplitGaugeSvg_backgroundArc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        d: x.to(SplitGaugeSvg_arcPathFromProgress),
                        fill: "url(#blue-gradient-split-gauge)",
                        opacity: stylesBlue.opacity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        d: x.to(SplitGaugeSvg_arcPathFromProgress),
                        fill: "url(#orange-gradient-split-gauge)",
                        opacity: stylesOrange.opacity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        d: needlePath,
                        opacity: stylesBlue.opacity,
                        style: {
                            fill: "#67e8f9"
                        },
                        transform: x.to(rotationFromProgress)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.path, {
                        transform: x.to(rotationFromProgress),
                        opacity: stylesOrange.opacity,
                        style: {
                            fill: colors/* default.orange400 */.Z.orange400
                        },
                        d: needlePath
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Gauges_SplitGaugeSvg = (SplitGaugeSvg);

;// CONCATENATED MODULE: ./src/mainsite/components/Gauges/SupplyGrowthGauge.tsx











const SupplyGrowthGauge_getRate = (gaugeRates, simulateProofOfWork, timeFrame)=>gaugeRates === undefined ? undefined : simulateProofOfWork ? gaugeRates[timeFrame].supply_growth_rate_yearly_pow : gaugeRates[timeFrame].supply_growth_rate_yearly;
const SupplyGrowthGauge = (param)=>{
    let { onClickTimeFrame , simulateProofOfWork , timeFrame  } = param;
    const gaugeRates = (0,gauge_rates/* useGaugeRates */.f)();
    const growthRate = SupplyGrowthGauge_getRate(gaugeRates, simulateProofOfWork, timeFrame);
    const toPercentTwoDigitSigned = (0,react.useCallback)((n)=>format/* formatPercentTwoDecimalSigned */.jc(n), []);
    // Workaround as react-spring is breaking our positive number with sign formatting.
    const [freezeAnimated, setFreezeAnimated] = (0,react.useState)(true);
    const { growthRateAnimated  } = (0,react_spring_web_esm.useSpring)({
        from: {
            growthRateAnimated: 0
        },
        to: {
            growthRateAnimated: growthRate
        },
        delay: 200,
        config: react_spring_web_esm.config.gentle,
        onRest: ()=>{
            setFreezeAnimated(true);
        },
        onStart: ()=>{
            setFreezeAnimated(false);
        }
    });
    const max = 5;
    const progress = clamp_default()((growthRate !== null && growthRate !== void 0 ? growthRate : 0) * 100, -max, max) / max;
    const { previewSkeletons  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n        flex flex-col items-center\n        justify-start\n        rounded-tl-lg rounded-tr-lg bg-slateus-700 px-4\n        pb-4 pt-7\n        md:rounded-none md:px-0\n      ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                children: "supply growth"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 md:scale-90 lg:scale-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_SplitGaugeSvg, {
                        max: max,
                        progress: progress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.div, {
                        className: "\n            -mt-[60px] bg-gradient-to-r bg-clip-text text-center font-roboto text-3xl font-light text-transparent\n            ".concat(growthRate !== undefined && growthRate > 0 ? "from-cyan-300 to-indigo-500" : "from-orange-400 to-yellow-300", "\n          "),
                        children: growthRate === undefined || previewSkeletons ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                inline: true,
                                width: "46px"
                            })
                        }) : freezeAnimated ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "-mb-2",
                            children: format/* formatPercentTwoDecimalSigned */.jc(growthRateAnimated.get())
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_web_esm.animated.p, {
                            className: "-mb-2",
                            children: growthRateAnimated.to(toPercentTwoDigitSigned)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-[7px] mb-2.5 select-none font-roboto text-xs font-light text-slateus-200",
                children: "/year"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-6 items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameIndicator/* default */.Z, {
                    onClickTimeFrame: onClickTimeFrame,
                    timeFrame: timeFrame
                })
            })
        ]
    });
};
/* harmony default export */ var Gauges_SupplyGrowthGauge = (SupplyGrowthGauge);

// EXTERNAL MODULE: ./src/components/TimeFrameControl.tsx + 3 modules
var TimeFrameControl = __webpack_require__(5429);
;// CONCATENATED MODULE: ./src/mainsite/components/GaugeWidget.tsx
// Rendering the D3 arc paths on the server vs the safari client results in a different path. We ignore the hydration warning.









const Controls = (param)=>/*#__PURE__*/ {
    let { onSetTimeFrame , onSetUnit , onSimulateProofOfWork , simulateProofOfWork , timeFrame , unit  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "rounded-bl-lg rounded-br-lg bg-slateus-700 px-8 pb-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-8 md:flex-row md:justify-between lg:gap-y-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-4 lg:flex-row lg:gap-x-4 lg:items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: "time frame"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameControl/* default */.Z, {
                            selectedTimeFrame: timeFrame,
                            onSetTimeFrame: onSetTimeFrame
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-4 lg:flex-row lg:gap-x-4 lg:items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: "currency"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyControl/* default */.Z, {
                            selectedUnit: unit,
                            onSetUnit: onSetUnit
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-4 items-center text-left md:flex-col md:text-right lg:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                            font: "font-inter",
                            color: "text-slateus-200",
                            className: "text-xs tracking-widest",
                            children: "SIMULATE PoW"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center self-start md:self-end h-[34px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch/* default */.Z, {
                                checked: simulateProofOfWork,
                                onToggle: onSimulateProofOfWork
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const GaugeWidget = (param)=>/*#__PURE__*/ {
    let { onClickTimeFrame , onSetTimeFrame , onSetUnit , onSimulateProofOfWork , simulateProofOfWork , timeFrame , unit  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full md:flex-row isolate",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden w-1/3 md:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_BurnGauge, {
                            timeFrame: timeFrame,
                            unit: unit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:w-1/3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_SupplyGrowthGauge, {
                            onClickTimeFrame: onClickTimeFrame,
                            simulateProofOfWork: simulateProofOfWork,
                            timeFrame: timeFrame
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden w-1/3 md:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gauges_IssuanceGauge, {
                            simulateProofOfWork: simulateProofOfWork,
                            timeFrame: timeFrame,
                            unit: unit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls, {
                onSetTimeFrame: onSetTimeFrame,
                onSetUnit: onSetUnit,
                onSimulateProofOfWork: onSimulateProofOfWork,
                simulateProofOfWork: simulateProofOfWork,
                timeFrame: timeFrame,
                unit: unit
            })
        ]
    });
};
/* harmony default export */ var components_GaugeWidget = (GaugeWidget);

;// CONCATENATED MODULE: ./src/assets/droplet-own.svg
/* harmony default export */ var droplet_own = ({"src":"/_next/static/media/droplet-own.08c4293b.svg","height":100,"width":100});
// EXTERNAL MODULE: ./src/assets/fire-own.svg
var fire_own = __webpack_require__(83915);
;// CONCATENATED MODULE: ./src/components/TextsNext/BodyTextV3.tsx


const BodyTextV3 = (param)=>/*#__PURE__*/ {
    let { children , className , color , inline , size ="text-sm sm:text-base"  } = param;
    return (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
        className: className,
        color: color,
        font: "font-inter",
        inline: inline,
        size: size,
        lineHeight: "leading-[18px] sm:leading-[21px]",
        children: children
    });
};
/* harmony default export */ var TextsNext_BodyTextV3 = (BodyTextV3);

;// CONCATENATED MODULE: ./src/mainsite/api/average-eth-price.ts



const average_eth_price_url = "/api/v2/fees/average-eth-price";
const fetchAverageEthPrice = ()=>fetchApiJson(average_eth_price_url);
const useAverageEthPrice = ()=>{
    const { data  } = (0,dist/* default */.ZP)(average_eth_price_url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(8)
    });
    return {
        m5: 1500,
        h1: 1500,
        d1: 1500,
        d7: 1500,
        d30: 1500,
        since_merge: 1500,
        since_burn: 1500
    };
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};

// EXTERNAL MODULE: ./src/mainsite/api/burn-sums.ts
var burn_sums = __webpack_require__(46983);
;// CONCATENATED MODULE: ./src/mainsite/api/supply-changes.ts

const deltaFromSeries = (series, ethUsdPrice)=>{
    if (series.length < 2) {
        return fp.O.none;
    }
    const first = series[0];
    const last = series[series.length - 1];
    if (first === undefined || last === undefined) {
        return fp.O.none;
    }
    const delta = last[1] - first[1];
    return fp.O.some({
        eth: delta,
        usd: delta * ethUsdPrice
    });
};
const deltaFromPoints = (first, last, ethUsdPrice)=>{
    if (first === undefined || last === undefined) {
        return fp.O.none;
    }
    const delta = last[1] - first[1];
    return fp.O.some({
        eth: delta,
        usd: delta * ethUsdPrice
    });
};
const supplyChangesForTimeFrame = (supplySeriesCollections, ethUsdPrice, burned, timeFrame)=>{
    const supplySeries = supplySeriesCollections[timeFrame];
    const deltaPos = deltaFromSeries(supplySeries.posSeries, ethUsdPrice);
    const deltaPow = // Since burn is a special case. Simulating added proof-of-work
    // from the London hardfork doesn't make sense. It only makes sense
    // to simulate from the merge. This means that the first point in the
    // proof-of-work series is not the point to calculate the delta
    // against. Instead, in that one case, we should use the first point
    // in the proof-of-stake series.
    timeFrame === "since_burn" ? deltaFromPoints(supplySeries.posSeries[0], supplySeries.powSeries[supplySeries.powSeries.length - 1], ethUsdPrice) : deltaFromSeries(supplySeries.powSeries, ethUsdPrice);
    return (0,fp/* pipe */.zG)(fp/* OAlt.sequenceStruct */.n.sequenceStruct({
        pos: deltaPos,
        pow: deltaPow
    }), fp.O.map((delta)=>{
        const timestamp = supplySeries.timestamp;
        const issued = {
            pos: {
                eth: delta.pos.eth + burned,
                usd: delta.pos.usd + burned
            },
            pow: {
                eth: delta.pow.eth + burned,
                usd: delta.pow.usd + burned
            }
        };
        return {
            burned: {
                eth: burned,
                usd: burned
            },
            delta,
            issued,
            timestamp
        };
    }));
};

// EXTERNAL MODULE: ./src/mainsite/api/supply-over-time.ts + 1 modules
var supply_over_time = __webpack_require__(99851);
;// CONCATENATED MODULE: ./src/mainsite/components/SimulateProofOfWork.tsx




const SimulateProofOfWork = (param)=>/*#__PURE__*/ {
    let { checked , onToggle , tooltipPosition ="bottom" , tooltipText  } = param;
    return (0,jsx_runtime.jsx)(HoverTooltip/* default */.Z, {
        position: tooltipPosition,
        text: tooltipText,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-x-2 items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                    font: "font-inter",
                    color: "text-slateus-200",
                    className: "text-xs tracking-widest",
                    children: "SIMULATE PoW"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch/* default */.Z, {
                    checked: checked,
                    onToggle: onToggle
                })
            ]
        })
    });
};
/* harmony default export */ var components_SimulateProofOfWork = (SimulateProofOfWork);

;// CONCATENATED MODULE: ./src/mainsite/components/SupplyChangeWidget/index.tsx





















const deltaFromChanges = (supplyChanges, simulateProofOfWork)=>(0,fp/* pipe */.zG)(supplyChanges, fp.O.map((supplyChange)=>(simulateProofOfWork ? supplyChange.delta.pow : supplyChange.delta.pos).eth));
const gradientFromDelta = (delta)=>(0,fp/* pipe */.zG)(delta, fp.O.map((delta)=>delta >= 0), fp.O.getOrElse(()=>false), (isPositiveSupplyDelta)=>isPositiveSupplyDelta ? "from-cyan-300 to-indigo-500" : "from-orange-400 to-yellow-300");
const timestampFromChanges = (supplyChanges)=>(0,fp/* pipe */.zG)(supplyChanges, fp.O.map((supplyChanges)=>supplyChanges.timestamp), fp.O.toUndefined);
const SupplyChange = (param)=>{
    let { onClickTimeFrame , onSimulateProofOfWork , simulateProofOfWork , timeFrame  } = param;
    const burnSums = (0,burn_sums/* useBurnSums */.I)();
    const supplySeriesCollections = (0,supply_over_time/* useSupplySeriesCollections */.It)();
    const averageEthPrice = useAverageEthPrice();
    const supplyChanges = (0,react.useMemo)(()=>(0,fp/* pipe */.zG)(supplySeriesCollections, fp.O.chain((collection)=>supplyChangesForTimeFrame(collection, averageEthPrice[timeFrame], burnSums[timeFrame].sum.eth, timeFrame))), [
        averageEthPrice,
        burnSums,
        supplySeriesCollections,
        timeFrame
    ]);
    const delta = deltaFromChanges(supplyChanges, simulateProofOfWork);
    const showUnavailable = fp.O.isSome(supplySeriesCollections) && fp.O.isNone(supplyChanges);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetErrorBoundary/* default */.Z, {
        title: "supply change",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex relative flex-col gap-x-2 gap-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                children: "supply change"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameIndicator/* default */.Z, {
                                onClickTimeFrame: onClickTimeFrame,
                                timeFrame: timeFrame
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            showUnavailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 flex items-center justify-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                    color: "text-slateus-300",
                                    children: "data unavailable"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "\n                flex flex-col gap-x-4 gap-y-4 justify-between\n                sm:flex-row md:flex-col xl:flex-row\n                ".concat(showUnavailable ? "invisible" : "", "\n              "),
                                "aria-hidden": showUnavailable,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                                        color: "\n                  text-transparent bg-gradient-to-r bg-clip-text\n                  ".concat(gradientFromDelta(delta), "\n                "),
                                        size: "text-2xl sm:text-3xl",
                                        lineHeight: "leading-8",
                                        unitPostfix: "ETH",
                                        unitPostfixColor: "text-slateus-200",
                                        unitPostfixMargin: "ml-1 sm:ml-2",
                                        children: (0,fp/* pipe */.zG)(delta, fp.O.match(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                                width: "7rem"
                                            }), (delta)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                decimals: 2,
                                                duration: 0.8,
                                                end: delta,
                                                formattingFn: format/* formatTwoDecimalsSigned */._K,
                                                preserveValue: true,
                                                separator: ","
                                            })))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-end w-fit",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-x-2 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                                                            alt: "fire icon signifying burned ETH",
                                                            height: 15,
                                                            priority: true,
                                                            src: fire_own/* default */.Z,
                                                            width: 15
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                                                        size: "text-xs",
                                                        weight: "font-medium",
                                                        unitPostfix: "ETH",
                                                        unitPostfixColor: "text-slateus-200",
                                                        children: (0,fp/* pipe */.zG)(supplyChanges, fp.O.match(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                                                width: "4rem"
                                                            }), (supplyChanges)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                                decimals: 2,
                                                                duration: 0.8,
                                                                end: supplyChanges.burned.eth,
                                                                preserveValue: true,
                                                                separator: ","
                                                            })))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextsNext_BodyTextV3, {
                                                        className: "-ml-1",
                                                        size: "text-xs",
                                                        children: "burned"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-x-2 justify-between items-center w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                                                            alt: "drop icon signifying issued ETH",
                                                            height: 15,
                                                            priority: true,
                                                            src: droplet_own,
                                                            width: 15
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex gap-x-2 items-baseline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                                                                size: "text-xs",
                                                                unitPostfix: "ETH",
                                                                unitPostfixColor: "text-slateus-200",
                                                                children: (0,fp/* pipe */.zG)(supplyChanges, fp.O.match(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                                                        width: "4rem"
                                                                    }), (supplyChanges)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                                        decimals: 2,
                                                                        duration: 0.8,
                                                                        end: supplyChanges.issued[simulateProofOfWork ? "pow" : "pos"].eth,
                                                                        preserveValue: true,
                                                                        separator: ","
                                                                    })))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextsNext_BodyTextV3, {
                                                                className: "-ml-1 w-[39.84px]",
                                                                size: "text-xs",
                                                                children: "issued"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap gap-x-4 gap-y-4 justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatedAgo/* default */.Z, {
                                updatedAt: timestampFromChanges(supplyChanges)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimulateProofOfWork, {
                                checked: simulateProofOfWork,
                                onToggle: onSimulateProofOfWork,
                                tooltipText: "Simulate the supply change with proof-of-work issuance."
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var SupplyChangeWidget = (SupplyChange);

;// CONCATENATED MODULE: ./src/mainsite/sections/SupplyDashboard.tsx







const SupplyDashboard_EthSupplyWidget = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(898), __webpack_require__.e(741), __webpack_require__.e(111), __webpack_require__.e(344), __webpack_require__.e(40)]).then(__webpack_require__.bind(__webpack_require__, 96040)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96040)
            ]
    }
});
const SupplyDashboard = (param)=>{
    let { timeFrame , onClickTimeFrame , onSetTimeFrame  } = param;
    const [simulateProofOfWork, setSimulateProofOfWork] = (0,react.useState)(false);
    const [unit, setUnit] = (0,react.useState)("eth");
    const handleSimulateProofOfWork = (0,react.useCallback)(()=>{
        setSimulateProofOfWork((simulateProofOfWork)=>!simulateProofOfWork);
    }, []);
    const handleSetUnit = (0,react.useCallback)((unit)=>{
        setUnit(unit);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-4 mt-16 md:px-16 xs:px-4",
            id: "merge",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-x-4 gap-y-4 mt-16 lg:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex lg:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyDashboard_EthSupplyWidget, {
                                onClickTimeFrame: onClickTimeFrame,
                                onSimulateProofOfWork: handleSimulateProofOfWork,
                                simulateProofOfWork: simulateProofOfWork,
                                timeFrame: timeFrame
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-y-4 lg:w-1/2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyChangeWidget, {
                                    simulateProofOfWork: simulateProofOfWork,
                                    onSimulateProofOfWork: handleSimulateProofOfWork,
                                    onClickTimeFrame: onClickTimeFrame,
                                    timeFrame: timeFrame,
                                    unit: unit
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSupplyWidget, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GaugeWidget, {
                    onClickTimeFrame: onClickTimeFrame,
                    onSimulateProofOfWork: handleSimulateProofOfWork,
                    onSetTimeFrame: onSetTimeFrame,
                    simulateProofOfWork: simulateProofOfWork,
                    timeFrame: timeFrame,
                    onSetUnit: handleSetUnit,
                    unit: unit
                })
            ]
        })
    });
};
/* harmony default export */ var sections_SupplyDashboard = (SupplyDashboard);

// EXTERNAL MODULE: ./src/components/AdminTools.tsx
var AdminTools = __webpack_require__(94191);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(20929);
;// CONCATENATED MODULE: ./src/mainsite/Dashboards.tsx
































// We get hydration errors in production.
// It's hard to tell what component causes them due to minification.
// We stop SSR on all components, and slowly turn them back on one-by-one to see which cause hydration issues.
// On: MergeSection, JoinDiscordSection
// Off: SupplyDashboard, BurnDashboard, MonetaryPremiumSection, FamSection, TotalValueSecuredSection.
const TotalValueSecuredSection = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(585), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 17726)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17726)
            ]
    },
    ssr: false
});
const MonetaryPremiumSection = dynamic_default()(()=>__webpack_require__.e(/* import() */ 420).then(__webpack_require__.bind(__webpack_require__, 62420)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(62420)
            ]
    },
    ssr: false
});
const SupplyProjectionsSection = dynamic_default()(()=>__webpack_require__.e(/* import() */ 333).then(__webpack_require__.bind(__webpack_require__, 87333)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87333)
            ]
    },
    ssr: false
});
// Likely culprit.
const BurnDashboard = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(585), __webpack_require__.e(655)]).then(__webpack_require__.bind(__webpack_require__, 31655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31655)
            ]
    },
    ssr: false
});
const useGasPriceTitle = (defaultTitle)=>{
    const [gasTitle, setGasTitle] = (0,react.useState)();
    const baseFeePerGas = useBaseFeePerGas();
    const ethPriceStats = (0,eth_price_stats/* useEthPriceStats */.U)();
    (0,react.useEffect)(()=>{
        if ( false || fp.O.isNone(baseFeePerGas) || ethPriceStats === undefined) {
            return undefined;
        }
        (0,fp/* pipe */.zG)(baseFeePerGas, fp.O.map((baseFeePerGas)=>baseFeePerGas.wei / eth_units/* WEI_PER_GWEI */.c1), fp.O.map((baseFeePerGas)=>baseFeePerGas.toFixed(0)), fp.O.map((gasFormatted)=>"".concat(gasFormatted, " Gwei | $").concat((0,format/* formatZeroDecimals */.UY)(ethPriceStats.usd), " ").concat(defaultTitle)), fp.O.match(()=>undefined, (title)=>{
            setGasTitle(title);
        }));
    }, [
        baseFeePerGas,
        defaultTitle,
        ethPriceStats
    ]);
    return gasTitle;
};
// By default a browser doesn't scroll to a section with a given ID matching the # in the URL.
const useScrollOnLoad = ()=>{
    const [authFromSection, setAuthFromSection] = use_auth_from_section();
    (0,react.useEffect)(()=>{
        if ( false || typeof document === undefined) {
            return undefined;
        }
        if (authFromSection !== "empty") {
            var ref;
            (ref = document.querySelector("#".concat(authFromSection))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "auto",
                block: "start"
            });
            setAuthFromSection("empty");
        }
        if (window.location.hash.length > 0) {
            var ref1;
            (ref1 = document.querySelector(window.location.hash.toLowerCase())) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
                behavior: "auto",
                block: "start"
            });
        }
    // The useAuthFromSection deps are missing intentionally here, we only want
    // this to run once on load. Because we disable the exhaustive deps linting
    // rule for this reason do check anything you add above doesn't need to be
    // in there.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
// This is a component to avoid triggering a render on the whole Dashboard.
const GasPriceTitle = ()=>{
    const gasPriceTitle = useGasPriceTitle("| ultrasound.money");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
            children: gasPriceTitle
        })
    });
};
const useIsDeflationary = ()=>{
    const ethSupplyParts = (0,supply_parts/* useSupplyParts */._D)();
    const ethSupply = jsbi_umd_default().toNumber((0,supply_parts/* ethSupplyFromParts */.us)(ethSupplyParts)) / 1e18;
    const [isDeflationary, setIsDeflationary] = (0,react.useState)(false);
    const { simulateDeflationary  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    (0,react.useEffect)(()=>{
        if (ethSupply > paris/* MERGE_SUPPLY */.yO) {
            setIsDeflationary(false);
            return;
        }
        setIsDeflationary(true);
    }, [
        ethSupply,
        setIsDeflationary
    ]);
    // simulateDeflationary doesn't work in the Dashboard component as the FeatureFlagsContext is not available.
    return isDeflationary || simulateDeflationary;
};
const Dashboard = ()=>{
    useScrollOnLoad();
    const { featureFlags , setFlag  } = (0,feature_flags/* useFeatureFlags */.gV)();
    const router = (0,next_router.useRouter)();
    const timeFrame = router.query.timeFrame || "d7";
    const isDeflationary = useIsDeflationary();
    const videoEl = (0,react.useRef)(null);
    const { simulateDeflationary  } = featureFlags;
    const showVideo = isDeflationary || simulateDeflationary;
    const handleClickTimeFrame = (0,react.useCallback)(async (e)=>{
        const newTimeFrame = e.shiftKey ? (0,time_frames/* getPreviousTimeFrame */.SV)(timeFrame) : (0,time_frames/* getNextTimeFrame */.z9)(timeFrame);
        await router.push({
            pathname: router.pathname,
            query: {
                ...router.query,
                timeFrame: newTimeFrame
            }
        }, undefined, {
            shallow: true
        });
    }, [
        timeFrame,
        router
    ]);
    const handleSetTimeFrame = (0,react.useCallback)(async (newTimeFrame)=>{
        await router.push({
            pathname: router.pathname,
            query: {
                ...router.query,
                timeFrame: newTimeFrame
            }
        }, undefined, {
            shallow: true
        });
    }, [
        router
    ]);
    const handleToggleBatLoop = (0,react.useCallback)(()=>{
        if (videoEl.current === null) {
            return;
        }
        videoEl.current.paused ? videoEl.current.play().catch(console.error) : videoEl.current.pause();
    }, []);
    const version = config/* versionFromEnv */.g();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_flags/* FeatureFlagsContext.Provider */.JN.Provider, {
        value: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_loading_skeleton_dist/* SkeletonTheme */.y, {
            baseColor: colors/* default.slateus500 */.Z.slateus500,
            highlightColor: "#565b7f",
            enableAnimation: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GasPriceTitle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderGlow/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicErrorBoundary/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminTools/* default */.Z, {
                                setFlag: setFlag
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-4 md:px-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicErrorBoundary/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TopBar, {})
                            })
                        }),
                        showVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoEl,
                            className: "\n                absolute left-0 right-0 top-10 -z-10 mx-auto\n                md:-top-10\n                ".concat(isDeflationary || simulateDeflationary ? "" : "hidden", "\n              "),
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            playsInline: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "/bat-480.mov",
                                    type: "video/mp4;codecs=hvc1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "/bat-480.webm",
                                    type: "video/webm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTitle/* default */.Z, {
                            onClick: handleToggleBatLoop,
                            children: "ultra sound money"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_SupplyDashboard, {
                            onClickTimeFrame: handleClickTimeFrame,
                            onSetTimeFrame: handleSetTimeFrame,
                            timeFrame: timeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_GasSection, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: handleClickTimeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_BlobGasSection, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: handleClickTimeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyProjectionsSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BurnDashboard, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: handleClickTimeFrame,
                            onSetTimeFrame: handleSetTimeFrame
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_FlippeningSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalValueSecuredSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MonetaryPremiumSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_FamSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-32 flex px-4 md:px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-full md:m-auto lg:w-2/3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSection/* default */.Z, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full justify-center text-slateus-600",
                    children: [
                        "version ",
                        version
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Dashboards = (Dashboard);

// EXTERNAL MODULE: ./src/site-metadata.ts
var site_metadata = __webpack_require__(91718);
;// CONCATENATED MODULE: ./src/pages/index.tsx







const IndexPage = (param)=>/*#__PURE__*/ {
    let { fallback  } = param;
    return (0,jsx_runtime.jsxs)(BasicErrorBoundary/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: site_metadata/* default.description */.Z.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "ultra sound money, ethereum, ETH, sound money, fee burn, EIP-1559"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: site_metadata/* default.title */.Z.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: site_metadata/* default.description */.Z.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://ultrasound.money"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                defer: true,
                "data-domain": "ultrasound.money",
                "data-api": "https://ultrasound.money/cfw/event",
                src: "https://ultrasound.money/cfw/script.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
                value: {
                    fallback
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboards, {})
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 91718:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const metadata = {
    description: "watch ETH become ultra sound money",
    title: "Ultra Sound Money",
    image: "https://ultrasound.money/og-image.png"
};
/* harmony default export */ __webpack_exports__["Z"] = (metadata);


/***/ }),

/***/ 34614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qr": function() { return /* binding */ dateTimeFromSlot; },
/* harmony export */   "_G": function() { return /* binding */ DAYS_PER_YEAR; }
/* harmony export */ });
/* unused harmony exports SECONDS_PER_SLOT, SLOTS_PER_DAY */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42227);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61973);
/// An RFC 3339 date-time string.
const DAYS_PER_YEAR = 365.25;

const GENESIS_TIMESTAMP = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(1606824023);
const dateTimeFromSlot = (slot)=>date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(GENESIS_TIMESTAMP, slot * 12);
const SECONDS_PER_SLOT = 12;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const SLOTS_PER_MINUTE = SECONDS_PER_MINUTE / SECONDS_PER_SLOT;
const SLOTS_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR * SLOTS_PER_MINUTE;


/***/ }),

/***/ 60146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alarmInput":"AlarmInput_alarmInput__H5Egw","innerInput":"AlarmInput_innerInput__1n8um"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [550,100,314,614,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);